const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3601.104,
    y1: 4076.7903,
    x2: 1123.5618,
    y2: 999.8381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2919.517,2863.352c-56.908,59.91-110.754,98.546-153.297,129.071 c-500.081,358.813-1091.808,254.221-1217.568,228.678c-185.706-37.718-544.673-110.626-804.199-415.824 c-392.642-461.739-331.502-1189.195-26.942-1669.399c55.709-87.838,349.978-575.356,948.08-653.538 c361.964-47.315,783.899,48.114,1089.452,304.107C3396.426,1323.799,3350.766,2409.346,2919.517,2863.352z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1096.401,961.268c3.985,0.474,7.051,3.894,6.992,7.995c-0.126,8.969-0.645,18.066-1.539,27.037 c-0.435,4.365-4.326,7.551-8.689,7.115c-0.052-0.006-0.103-0.012-0.154-0.018c-4.284-0.51-7.391-4.359-6.96-8.672 c0.851-8.523,1.342-17.164,1.463-25.684c0.061-4.385,3.666-7.891,8.052-7.829 C1095.848,961.214,1096.127,961.235,1096.401,961.268z M1087.716,1029.899c0.308,0.037,0.619,0.092,0.928,0.166 c4.264,1.026,6.889,5.315,5.863,9.579c-2.109,8.758-4.613,17.512-7.444,26.018c-1.384,4.162-5.86,6.406-10.042,5.03 c-4.161-1.386-6.411-5.883-5.027-10.041c2.69-8.086,5.068-16.402,7.071-24.726 C1080.018,1031.972,1083.775,1029.43,1087.716,1029.899z M1064.136,1094.911c0.878,0.104,1.753,0.359,2.591,0.774 c3.927,1.951,5.532,6.715,3.583,10.644c-3.995,8.052-8.392,16.032-13.067,23.715c-2.282,3.745-7.167,4.929-10.912,2.656 c-3.745-2.28-4.935-7.166-2.656-10.912c4.44-7.296,8.614-14.871,12.409-22.519 C1057.617,1096.178,1060.896,1094.525,1064.136,1094.911z M1026.602,1153.029c1.451,0.173,2.871,0.748,4.085,1.742 c3.393,2.778,3.89,7.782,1.113,11.175c-5.702,6.959-11.771,13.755-18.04,20.2c-3.058,3.138-8.083,3.208-11.229,0.153 c-3.142-3.057-3.211-8.085-0.153-11.229c5.955-6.12,11.721-12.574,17.136-19.189 C1021.298,1153.704,1023.998,1152.719,1026.602,1153.029z M977.052,1201.318c2.035,0.242,3.974,1.267,5.33,3.012 c2.693,3.463,2.068,8.452-1.395,11.142c-7.084,5.507-14.505,10.79-22.055,15.695c-3.675,2.393-8.595,1.351-10.985-2.329 c-2.389-3.677-1.346-8.594,2.331-10.987c7.177-4.662,14.23-9.683,20.963-14.916 C972.958,1201.599,975.05,1201.08,977.052,1201.318z M918.058,1237.441c2.635,0.314,5.053,1.939,6.261,4.519 c1.859,3.973,0.147,8.698-3.824,10.559c-8.14,3.81-16.546,7.32-24.983,10.427c-4.118,1.515-8.68-0.593-10.196-4.709 c-1.516-4.113,0.593-8.679,4.707-10.195c8.017-2.953,16.003-6.285,23.737-9.906 C915.153,1237.482,916.636,1237.271,918.058,1237.441z M626.886,1221.821c1.092,0.13,2.172,0.49,3.173,1.096 c7.295,4.423,14.882,8.587,22.55,12.374c3.931,1.942,5.545,6.704,3.603,10.634c-1.941,3.933-6.703,5.546-10.636,3.604 c-8.075-3.988-16.067-8.373-23.75-13.029c-3.751-2.274-4.947-7.158-2.673-10.907 C620.818,1222.842,623.889,1221.464,626.886,1221.821z M852.568,1259.576c3.271,0.389,6.084,2.805,6.821,6.204 c0.93,4.287-1.791,8.514-6.077,9.444c-8.784,1.906-17.759,3.452-26.674,4.597c-4.351,0.538-8.33-2.513-8.888-6.865 c-0.558-4.349,2.516-8.328,6.867-8.888c8.466-1.085,16.988-2.554,25.33-4.363 C850.832,1259.514,851.716,1259.475,852.568,1259.576z M689.705,1250.783c0.52,0.062,1.043,0.174,1.56,0.345 c8.105,2.68,16.435,5.042,24.754,7.029c4.266,1.02,6.898,5.304,5.88,9.568c-1.02,4.264-5.303,6.919-9.568,5.88 c-8.753-2.091-17.518-4.578-26.047-7.395c-4.164-1.377-6.425-5.869-5.049-10.032 C682.438,1252.533,686.033,1250.346,689.705,1250.783z M783.775,1266.528c3.979,0.474,7.042,3.884,6.992,7.979 c-0.053,4.386-3.651,7.896-8.037,7.846c-8.978-0.11-18.073-0.608-27.031-1.487c-0.056-0.003-0.113-0.01-0.168-0.017 c-4.278-0.509-7.382-4.349-6.962-8.657c0.428-4.366,4.311-7.558,8.677-7.13c8.509,0.832,17.147,1.304,25.678,1.407 C783.211,1266.477,783.496,1266.495,783.775,1266.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M582.015,1188.719c1.552,0.185,3.068,0.827,4.326,1.945c3.061,2.719,6.23,5.418,9.418,8.028 c3.395,2.775,3.897,7.78,1.121,11.173c-2.775,3.396-7.782,3.903-11.174,1.119c-3.355-2.742-6.687-5.582-9.909-8.442 c-3.279-2.911-3.578-7.932-0.667-11.209C576.925,1189.31,579.52,1188.422,582.015,1188.719z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M478.132,970.046c3.806,0.453,6.827,3.611,6.987,7.563c0.164,4.09,0.418,8.246,0.754,12.35 c0.357,4.372-2.896,8.205-7.267,8.563c-4.389,0.358-8.205-2.898-8.563-7.267c-0.352-4.321-0.62-8.698-0.795-13.005 c-0.177-4.382,3.232-8.077,7.614-8.255C477.294,969.977,477.718,969.996,478.132,970.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M823.385,650.182c3.628,0.432,7.263,0.927,10.903,1.485c4.335,0.666,7.31,4.719,6.646,9.053 c-0.664,4.335-4.74,7.323-9.052,6.648c-8.401-1.288-16.835-2.232-25.164-2.811c-4.378-0.312-7.675-4.097-7.371-8.471 c0.304-4.378,4.099-7.678,8.473-7.373C812.972,649.071,818.209,649.566,823.385,650.182z M875.196,660.838 c0.44,0.052,0.884,0.143,1.325,0.273c8.496,2.514,16.979,5.416,25.214,8.627c4.085,1.592,6.107,6.196,4.515,10.28 c-1.594,4.087-6.207,6.117-10.283,4.514c-7.821-3.049-15.88-5.804-23.953-8.196c-4.205-1.244-6.604-5.662-5.36-9.865 C867.768,662.706,871.425,660.389,875.196,660.838z M766.032,648.712c3.718,0.443,6.713,3.476,6.975,7.346 c0.296,4.377-3.011,8.163-7.387,8.461c-8.37,0.565-16.829,1.498-25.147,2.776c-4.336,0.658-8.389-2.311-9.054-6.644 c-0.664-4.337,2.311-8.39,6.646-9.055c8.758-1.344,17.668-2.326,26.483-2.923C765.052,648.639,765.549,648.655,766.032,648.712 z M937.963,687.236c1.001,0.119,1.994,0.434,2.929,0.955c7.728,4.315,15.366,9.013,22.698,13.963 c3.634,2.453,4.592,7.388,2.138,11.022c-2.454,3.638-7.387,4.597-11.024,2.14c-6.963-4.699-14.214-9.161-21.555-13.258 c-3.83-2.136-5.2-6.976-3.062-10.804C931.703,688.359,934.863,686.867,937.963,687.236z M699.08,660.797 c3.049,0.363,5.742,2.489,6.675,5.621c1.252,4.203-1.141,8.626-5.344,9.878c-8.036,2.392-16.083,5.164-23.919,8.236 c-4.083,1.601-8.691-0.41-10.291-4.496c-1.599-4.082,0.412-8.688,4.495-10.288c8.249-3.235,16.721-6.153,25.183-8.673 C696.949,660.756,698.036,660.673,699.08,660.797z M636.399,687.281c2.438,0.29,4.707,1.704,5.998,4.009 c2.14,3.828,0.772,8.667-3.056,10.807c-7.341,4.106-14.594,8.568-21.558,13.262c-3.633,2.457-8.567,1.498-11.023-2.143 c-2.452-3.637-1.491-8.571,2.145-11.024c7.329-4.94,14.962-9.636,22.687-13.955 C633.112,687.387,634.792,687.09,636.399,687.281z M580.984,726.801c1.854,0.221,3.637,1.092,4.979,2.595 c2.922,3.269,2.64,8.289-0.63,11.211c-6.278,5.609-12.386,11.542-18.157,17.64c-3.014,3.184-8.037,3.326-11.226,0.307 c-3.184-3.016-3.323-8.039-0.307-11.226c6.074-6.415,12.503-12.662,19.107-18.564 C576.519,727.184,578.8,726.541,580.984,726.801z M535.509,777.461c1.285,0.153,2.549,0.622,3.675,1.428 c3.567,2.552,4.388,7.51,1.836,11.076c-4.897,6.842-9.555,13.969-13.847,21.186c-2.242,3.769-7.12,5.006-10.883,2.768 c-3.77-2.242-5.008-7.115-2.767-10.884c4.52-7.602,9.426-15.109,14.58-22.311C529.852,778.284,532.726,777.13,535.509,777.461z  M502.252,836.892c0.722,0.086,1.445,0.275,2.148,0.571c4.041,1.702,5.937,6.36,4.233,10.4 c-3.258,7.734-6.23,15.708-8.832,23.707c-1.357,4.171-5.85,6.445-10.007,5.094c-4.171-1.356-6.452-5.838-5.095-10.009 c2.739-8.42,5.867-16.816,9.299-24.957C495.405,838.36,498.827,836.484,502.252,836.892z M482.877,902.133 c0.162,0.019,0.324,0.045,0.486,0.073c4.314,0.782,7.179,4.915,6.395,9.229c-1.105,6.091-2.034,12.287-2.764,18.423 c-0.264,2.221-0.502,4.441-0.717,6.656c-0.424,4.366-4.307,7.562-8.671,7.136c-4.428-0.343-7.559-4.305-7.137-8.668 c0.226-2.332,0.477-4.663,0.755-7.001c0.768-6.453,1.747-12.974,2.91-19.38C474.885,904.449,478.742,901.64,482.877,902.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M993.513,726.938c1.568,0.187,3.094,0.84,4.357,1.971c3.201,2.87,6.401,5.863,9.512,8.894 c3.142,3.061,3.208,8.088,0.147,11.229c-3.062,3.14-8.085,3.211-11.229,0.147c-2.956-2.879-5.996-5.721-9.034-8.447 c-3.264-2.925-3.538-7.946-0.61-11.212C988.453,727.519,991.034,726.643,993.513,726.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M971.987,817.129c-0.849-1.336-2.453-1.987-3.993-1.62l-43.94,10.47 c-15.074-14.756-32.61-27.216-52.162-36.649l-5.074-44.855c-0.178-1.574-1.335-2.86-2.88-3.205l-52.883-11.794 c-1.546-0.344-3.139,0.33-3.969,1.677l-23.652,38.449c-21.708,0.232-42.875,4.059-62.791,11.013l-35.328-28.148 c-1.238-0.986-2.966-1.079-4.302-0.23L635.28,781.29c-1.337,0.85-1.988,2.453-1.62,3.993l10.47,43.94 c-14.757,15.074-27.216,32.61-36.649,52.162l-44.856,5.074c-1.573,0.178-2.86,1.334-3.205,2.88l-11.794,52.883 c-0.345,1.545,0.329,3.139,1.678,3.968l38.449,23.652c0.232,21.708,4.058,42.875,11.012,62.791l-28.149,35.329 c-0.986,1.238-1.078,2.966-0.23,4.302l29.054,45.733c0.849,1.337,2.453,1.987,3.993,1.62l43.94-10.47 c15.074,14.757,32.61,27.216,52.162,36.649l5.074,44.856c0.178,1.573,1.334,2.86,2.88,3.205l52.883,11.793 c1.545,0.345,3.139-0.329,3.969-1.678l23.652-38.449c21.708-0.231,42.876-4.059,62.792-11.012l35.328,28.148 c1.238,0.987,2.967,1.079,4.303,0.23l45.733-29.054c1.336-0.849,1.987-2.452,1.62-3.993l-10.47-43.94 c14.757-15.074,27.216-32.61,36.649-52.162l44.856-5.074c1.573-0.177,2.86-1.334,3.204-2.88l11.794-52.882 c0.344-1.546-0.329-3.139-1.677-3.969l-38.449-23.652c-0.232-21.707-4.059-42.875-11.012-62.791l28.148-35.328 c0.987-1.238,1.079-2.966,0.23-4.303L971.987,817.129z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M792.188,913.483c26.362,3.138,47.206,25.252,47.968,52.562 c0.836,30.021-22.906,55.121-52.925,55.959c-14.544,0.409-28.373-4.877-38.939-14.872 c-10.57-9.995-16.614-23.509-17.018-38.051c-0.836-30.022,22.906-55.121,52.924-55.959 C786.904,913.048,789.574,913.172,792.188,913.483z M780.69,1009.024c2.036,0.242,4.1,0.338,6.187,0.28 c23.015-0.641,41.219-19.89,40.578-42.903c-0.642-23.017-19.882-41.229-42.904-40.58c-23.015,0.64-41.219,19.89-40.578,42.903 c0.311,11.151,4.944,21.511,13.048,29.176C763.608,1004.13,771.849,1007.972,780.69,1009.024z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M800.379,835.241c4.528,0.539,9.055,1.309,13.565,2.314l0,0c1.42,0.316,2.835,0.656,4.245,1.018 c6.949,1.786,13.744,4.122,20.282,6.972c0.089,0.039,0.178,0.078,0.267,0.116c0.252,0.111,0.505,0.222,0.756,0.337 c0.491,0.218,0.98,0.442,1.467,0.665c1.282,0.59,1.984,1.926,1.827,3.257c-0.039,0.323-0.128,0.647-0.272,0.958 c-0.733,1.593-2.621,2.284-4.213,1.554c-8.198-3.778-16.858-6.696-25.741-8.674c-44.117-9.847-88.088,4.562-117.947,34.331 c-16.61,16.556-28.852,37.867-34.323,62.406c-0.961,4.303-1.697,8.622-2.209,12.941c-3.456,29.064,3.133,58.19,19.041,83.226 c18.271,28.761,46.649,48.685,79.904,56.101c68.683,15.31,136.961-28.088,152.271-96.736c0.944-4.233,1.67-8.498,2.178-12.776 c2.204-18.539,0.326-37.355-5.564-55.09c-0.152-0.458-0.194-0.926-0.14-1.375c0.141-1.183,0.946-2.239,2.153-2.639 c1.667-0.548,3.464,0.344,4.016,2.015c6.183,18.619,8.156,38.374,5.843,57.838c-0.533,4.491-1.295,8.967-2.285,13.41 c-16.073,72.075-87.805,117.624-159.854,101.557c-34.913-7.786-64.702-28.703-83.883-58.896 c-16.701-26.284-23.617-56.861-19.99-87.372c0.54-4.534,1.312-9.068,2.318-13.584c7.787-34.915,28.703-64.705,58.895-83.886 C739.276,838.523,769.862,831.608,800.379,835.241z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1390.214,785.503c2.107,0.251,3.884,1.856,4.254,4.056c0.693,4.105,1.271,8.288,1.716,12.432 c0.29,2.692-1.657,5.108-4.352,5.4c-2.696,0.301-5.11-1.66-5.401-4.352c-0.424-3.948-0.975-7.935-1.635-11.853 c-0.451-2.668,1.35-5.198,4.021-5.652C1389.291,785.456,1389.76,785.449,1390.214,785.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1393.046,823.124c2.468,0.294,4.362,2.415,4.318,4.951c-0.12,7.168-0.611,14.412-1.458,21.527 c-0.178,1.498-0.374,2.999-0.584,4.503c-0.38,2.685-2.99,4.433-5.54,4.178c-2.682-0.377-4.551-2.857-4.176-5.538 c0.202-1.437,0.39-2.872,0.561-4.303c0.808-6.787,1.276-13.696,1.392-20.531c0.045-2.71,2.277-4.866,4.985-4.823 C1392.714,823.094,1392.882,823.104,1393.046,823.124z M1385.958,873.552c0.23,0.027,0.464,0.07,0.693,0.13 c2.617,0.702,4.171,3.391,3.472,6.008c-2.244,8.396-5.03,16.727-8.279,24.757c-1.015,2.513-3.886,3.714-6.385,2.708 c-2.512-1.018-3.723-3.872-2.708-6.385c3.1-7.662,5.755-15.608,7.897-23.616 C1381.287,874.771,1383.575,873.269,1385.958,873.552z M1366.854,920.755c0.618,0.073,1.232,0.268,1.809,0.587 c2.365,1.319,3.211,4.309,1.892,6.674c-4.23,7.576-8.979,14.974-14.12,21.977c-1.604,2.187-4.665,2.657-6.856,1.051 c-2.183-1.601-2.654-4.672-1.053-6.854c4.902-6.68,9.431-13.729,13.463-20.956 C1362.987,921.448,1364.939,920.528,1366.854,920.755z M1336.727,961.819c1.009,0.12,1.986,0.554,2.782,1.301 c1.969,1.86,2.06,4.967,0.2,6.935c-5.969,6.322-12.38,12.326-19.062,17.849c-2.089,1.724-5.181,1.424-6.904-0.658 c-1.727-2.086-1.433-5.177,0.656-6.906c6.369-5.262,12.486-10.992,18.177-17.019 C1333.686,962.147,1335.237,961.642,1336.727,961.819z M1297.487,994.278c1.408,0.168,2.734,0.943,3.557,2.232 c1.457,2.281,0.788,5.312-1.494,6.773c-7.319,4.671-14.994,8.938-22.814,12.676c-2.445,1.175-5.373,0.137-6.541-2.308 c-1.168-2.445-0.134-5.374,2.308-6.54c7.462-3.569,14.783-7.636,21.765-12.096 C1295.264,994.38,1296.401,994.149,1297.487,994.278z M1251.564,1016.227c1.824,0.217,3.451,1.458,4.074,3.316 c0.859,2.567-0.528,5.344-3.095,6.206c-8.233,2.753-16.717,5.019-25.212,6.728c-2.665,0.527-5.241-1.188-5.777-3.842 c-0.535-2.654,1.186-5.242,3.839-5.775c8.102-1.631,16.187-3.789,24.036-6.414 C1250.141,1016.208,1250.867,1016.144,1251.564,1016.227z M1201.681,1026.28c2.283,0.272,4.129,2.126,4.307,4.501 c0.202,2.701-1.824,5.055-4.525,5.259c-8.629,0.647-17.411,0.759-26.105,0.337c-2.709-0.178-4.794-2.438-4.66-5.142 c0.131-2.705,2.432-4.79,5.137-4.661c8.293,0.408,16.67,0.301,24.897-0.316 C1201.054,1026.234,1201.371,1026.243,1201.681,1026.28z M1125.995,1017.897c0.281,0.033,0.566,0.091,0.847,0.178 c6.843,2.074,13.92,3.808,21.036,5.157c1.077,0.21,2.137,0.404,3.196,0.583c2.67,0.463,4.462,2.996,4.002,5.666 c-0.456,2.676-3.022,4.541-5.664,4.005c-1.129-0.197-2.256-0.399-3.385-0.62c-7.434-1.411-14.853-3.229-22.028-5.405 c-2.593-0.786-4.057-3.522-3.271-6.115C1121.426,1019.037,1123.676,1017.621,1125.995,1017.897z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1207.71,614.097c2.659,0.317,4.577,2.716,4.295,5.388c-0.284,2.692-2.7,4.647-5.393,4.36 c-8.109-0.859-16.34-1.231-24.463-1.103c-2.691,0.018-4.941-2.117-4.982-4.828c-0.042-2.711,2.121-4.938,4.828-4.982 c8.519-0.129,17.147,0.257,25.648,1.157C1207.643,614.089,1207.688,614.094,1207.71,614.097z M1232.458,618.234 c0.176,0.021,0.349,0.051,0.525,0.092c8.323,1.907,16.614,4.341,24.643,7.231c2.548,0.921,3.871,3.726,2.953,6.274 c-0.916,2.554-3.739,3.862-6.275,2.957c-7.661-2.759-15.573-5.08-23.514-6.903c-2.639-0.604-4.289-3.236-3.683-5.874 C1227.672,619.541,1230.004,617.942,1232.458,618.234z M1157.639,614.889c2.159,0.257,3.961,1.938,4.276,4.194 c0.374,2.678-1.496,5.157-4.18,5.532c-8.081,1.131-16.159,2.76-24.014,4.849c-2.626,0.686-5.304-0.863-5.998-3.483 c-0.697-2.615,0.863-5.304,3.48-6.001c8.234-2.189,16.704-3.896,25.174-5.078 C1156.807,614.843,1157.229,614.841,1157.639,614.889z M1279.591,635.237c0.554,0.066,1.106,0.228,1.634,0.493 c7.625,3.855,15.088,8.221,22.179,12.976c2.251,1.508,2.851,4.555,1.343,6.806c-1.506,2.242-4.554,2.844-6.804,1.341 c-6.763-4.533-13.877-8.693-21.146-12.371c-2.416-1.223-3.386-4.174-2.163-6.59C1275.59,636.005,1277.603,635,1279.591,635.237 z M1109.248,627.762c1.724,0.205,3.287,1.322,3.976,3.044c1.01,2.517-0.212,5.372-2.725,6.38 c-7.555,3.027-15.001,6.549-22.137,10.475c-2.377,1.309-5.358,0.438-6.662-1.936c-1.304-2.374-0.438-5.358,1.936-6.662 c7.483-4.111,15.291-7.807,23.21-10.984C1107.637,627.763,1108.461,627.668,1109.248,627.762z M1065.356,651.868 c1.32,0.157,2.569,0.846,3.405,2.007c1.581,2.199,1.081,5.265-1.119,6.846c-6.625,4.763-13.018,9.969-19,15.469 c-1.996,1.836-5.101,1.703-6.931-0.289c-1.834-1.993-1.704-5.094,0.289-6.926c6.272-5.77,12.973-11.228,19.915-16.219 C1062.951,652.011,1064.181,651.728,1065.356,651.868z M1028.5,685.797c0.927,0.11,1.833,0.483,2.597,1.138 c2.063,1.755,2.309,4.852,0.552,6.915c-5.294,6.204-10.25,12.792-14.731,19.575c-1.493,2.253-4.537,2.88-6.795,1.386 c-2.26-1.494-2.882-4.534-1.388-6.797c4.7-7.11,9.897-14.02,15.448-20.532C1025.289,686.187,1026.926,685.61,1028.5,685.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1321.39,663.273c0.939,0.112,1.856,0.496,2.626,1.162c3.175,2.746,6.281,5.6,9.238,8.479 c1.938,1.89,1.981,4.997,0.091,6.937c-1.892,1.931-4.993,1.976-6.937,0.09c-2.818-2.747-5.783-5.468-8.811-8.091 c-2.049-1.773-2.27-4.872-0.498-6.918C1318.205,663.656,1319.828,663.087,1321.39,663.273z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1309.853,725.705c-0.568-0.894-1.641-1.33-2.671-1.084l-29.403,7.006 c-10.087-9.874-21.821-18.212-34.904-24.524l-3.395-30.015c-0.119-1.053-0.893-1.914-1.927-2.145l-35.386-7.892 c-1.035-0.23-2.101,0.221-2.656,1.123l-15.827,25.729c-14.526,0.155-28.69,2.716-42.017,7.369l-23.64-18.836 c-0.829-0.66-1.985-0.722-2.88-0.154l-30.602,19.442c-0.895,0.569-1.33,1.642-1.084,2.672l7.006,29.402 c-9.875,10.087-18.212,21.821-24.524,34.905l-30.015,3.395c-1.053,0.119-1.914,0.893-2.145,1.927l-7.892,35.387 c-0.231,1.034,0.22,2.101,1.123,2.656l25.729,15.827c0.155,14.526,2.716,28.69,7.369,42.017l-18.836,23.641 c-0.66,0.828-0.722,1.984-0.154,2.878l19.442,30.603c0.568,0.894,1.641,1.329,2.671,1.084l29.403-7.007 c10.086,9.875,21.821,18.212,34.904,24.524l3.395,30.016c0.119,1.052,0.892,1.914,1.927,2.145l35.387,7.892 c1.034,0.231,2.1-0.22,2.656-1.123l15.827-25.729c14.526-0.155,28.691-2.716,42.018-7.369l23.639,18.835 c0.829,0.661,1.985,0.722,2.879,0.154l30.602-19.442c0.894-0.568,1.33-1.641,1.084-2.672l-7.006-29.402 c9.875-10.087,18.211-21.821,24.523-34.905l30.016-3.395c1.052-0.119,1.914-0.893,2.144-1.927l7.892-35.386 c0.23-1.034-0.22-2.101-1.123-2.656l-25.729-15.827c-0.155-14.526-2.716-28.69-7.368-42.017l18.835-23.64 c0.66-0.829,0.722-1.984,0.154-2.879L1309.853,725.705z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1189.671,789.534c7.856,0.935,15.177,4.348,21.03,9.883 c7.199,6.809,11.315,16.015,11.59,25.921c0.572,20.442-15.598,37.54-36.047,38.116c-20.476,0.534-37.549-15.607-38.118-36.052 c-0.277-9.907,3.321-19.327,10.13-26.524c6.809-7.201,16.015-11.319,25.923-11.592 C1186.028,789.236,1187.865,789.32,1189.671,789.534z M1181.966,853.467c1.311,0.156,2.646,0.218,4.004,0.182 c15.041-0.423,26.935-13,26.516-28.041c-0.204-7.283-3.229-14.059-8.525-19.064c-5.298-5.01-12.226-7.648-19.513-7.455l0,0 c-7.286,0.203-14.059,3.232-19.066,8.525c-5.01,5.298-7.656,12.227-7.453,19.516 C1158.31,840.812,1168.757,851.895,1181.966,853.467z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1195.443,735.081c3.082,0.367,6.169,0.894,9.261,1.58c6.139,1.367,12.145,3.361,17.866,5.932 c0.256,0.117,0.512,0.235,0.769,0.352c1.98,0.911,3.063,2.974,2.821,5.029c-0.059,0.499-0.198,0.999-0.419,1.479 c-1.133,2.46-4.047,3.522-6.505,2.399c-5.318-2.452-10.924-4.339-16.662-5.615l-0.002,0c-0.315-0.071-0.632-0.138-0.945-0.204 c-13.607-2.898-27.42-2.294-40.412,1.561c-7.052,2.093-13.865,5.151-20.27,9.139c-0.052,0.032-0.104,0.065-0.156,0.097 c-0.159,0.102-0.318,0.199-0.475,0.301c-18.617,11.83-31.517,30.2-36.317,51.729c-0.623,2.786-1.098,5.58-1.431,8.377 c-2.237,18.815,2.03,37.67,12.327,53.882c11.83,18.618,30.201,31.513,51.727,36.313c21.516,4.79,43.639,0.931,62.259-10.894 c18.617-11.829,31.517-30.2,36.317-51.729c0.613-2.739,1.081-5.5,1.411-8.268c1.426-12.005,0.211-24.183-3.602-35.663 c-0.234-0.708-0.301-1.43-0.215-2.124c0.217-1.826,1.461-3.458,3.324-4.076c2.573-0.847,5.346,0.535,6.202,3.111 c4.266,12.846,5.627,26.474,4.034,39.901c-0.369,3.101-0.893,6.188-1.576,9.252c-5.373,24.089-19.803,44.641-40.635,57.875 c-20.829,13.23-45.556,17.58-69.65,12.189c-24.087-5.37-44.639-19.798-57.871-40.632 c-11.523-18.133-16.295-39.229-13.792-60.279c0.372-3.125,0.904-6.255,1.598-9.369 C1104.822,760.093,1148.983,729.551,1195.443,735.081z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034773709047548270120000004271372166385769142_",
    gradientUnits: "userSpaceOnUse",
    x1: 2507.6135,
    y1: 750.1008,
    x2: 2957.3264,
    y2: -230.8677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034773709047548270120000004271372166385769142_)"
    },
    d: "M2666.561,722.022 c-1.232,0-2.462-0.318-3.656-0.945l-63.197-33.225c-4.546-2.39-9.662-3.653-14.797-3.653s-10.251,1.263-14.796,3.652 l-63.198,33.226c-1.193,0.628-2.424,0.945-3.656,0.945c-2.271,0-4.542-1.085-6.073-2.902c-1.04-1.233-2.171-3.33-1.659-6.318 l12.07-70.371c1.769-10.318-1.649-20.839-9.145-28.145l-51.128-49.837c-3.153-3.073-2.439-6.65-1.986-8.045 c0.453-1.395,1.978-4.709,6.336-5.342l70.656-10.267c10.358-1.505,19.308-8.007,23.941-17.394l31.599-64.026 c1.948-3.949,5.571-4.375,7.038-4.375c1.467,0,5.089,0.427,7.038,4.375l31.599,64.026c4.633,9.387,13.583,15.89,23.942,17.394 l70.656,10.267c4.358,0.633,5.882,3.947,6.336,5.342c0.453,1.395,1.167,4.972-1.986,8.045l-51.128,49.837 c-7.496,7.306-10.914,17.827-9.145,28.145l12.069,70.371c0.512,2.987-0.619,5.084-1.659,6.317 C2671.101,720.936,2668.831,722.022,2666.561,722.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "#FFFFFF"
    },
    d: "M2517.89,625.326c-0.757,0-1.462-0.482-1.708-1.242 c-2.095-6.446-5.768-12.354-10.623-17.086l-19.451-18.961c-0.71-0.692-0.725-1.829-0.032-2.54c0.692-0.71,1.829-0.725,2.54-0.033 l19.451,18.961c5.27,5.137,9.258,11.551,11.531,18.549c0.307,0.943-0.209,1.956-1.153,2.264 C2518.261,625.298,2518.073,625.326,2517.89,625.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "#FFFFFF"
    },
    d: "M2556.085,683.496c-0.646,0-1.27-0.35-1.591-0.961 c-0.462-0.878-0.124-1.964,0.754-2.426l8.46-4.448c6.514-3.424,13.846-5.233,21.204-5.233c7.358,0,14.69,1.81,21.205,5.234 c0.878,0.462,1.215,1.548,0.754,2.426c-0.461,0.879-1.547,1.216-2.426,0.754c-6.001-3.154-12.756-4.822-19.533-4.822 c-6.778,0-13.532,1.667-19.532,4.821l-8.46,4.448C2556.653,683.429,2556.366,683.496,2556.085,683.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "#FFFFFF"
    },
    d: "M2644.032,697.773c-1.409,0-2.828-0.208-4.219-0.632 c-0.948-0.29-1.482-1.294-1.193-2.242c0.29-0.949,1.292-1.484,2.243-1.193c3.639,1.112,7.555,0.239,10.477-2.335 c2.929-2.58,4.228-6.278,3.564-10.145l-6.255-36.467c-2.535-14.784,2.364-29.862,13.106-40.332l26.495-25.827 c3.082-3.003,4.128-7.239,2.797-11.332c-1.329-4.093-4.666-6.905-8.924-7.524l-36.614-5.321 c-14.845-2.156-27.672-11.474-34.311-24.927l-16.375-33.178c-1.905-3.859-5.611-6.163-9.914-6.163s-8.009,2.304-9.913,6.163 l-16.375,33.178c-6.639,13.452-19.466,22.771-34.309,24.927l-36.615,5.321c-2.184,0.317-4.175,1.232-5.76,2.647 c-0.74,0.661-1.875,0.596-2.536-0.145c-0.66-0.74-0.596-1.876,0.144-2.536c2.113-1.885,4.753-3.103,7.636-3.522l36.615-5.321 c13.674-1.986,25.488-10.57,31.604-22.962l16.375-33.178c2.486-5.036,7.519-8.165,13.135-8.165s10.649,3.129,13.135,8.165 l16.375,33.178c6.116,12.392,17.932,20.976,31.606,22.962l36.614,5.321c5.557,0.808,10.088,4.627,11.824,9.969 c1.735,5.342,0.315,11.095-3.707,15.015l-26.495,25.826c-9.895,9.645-14.407,23.533-12.072,37.153l6.255,36.468 c0.866,5.049-0.903,10.076-4.731,13.448C2650.96,696.492,2647.529,697.773,2644.032,697.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163793155024632875260000004999813158508812422_",
    gradientUnits: "userSpaceOnUse",
    x1: 3078.896,
    y1: 749.0486,
    x2: 2888.6333,
    y2: -26.8315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163793155024632875260000004999813158508812422_)"
    },
    d: "M3086.753,737.919 c-0.727-0.128-1.42-0.444-2.059-0.938l-33.828-26.175c-2.433-1.883-5.32-3.16-8.35-3.694c-3.029-0.534-6.179-0.321-9.109,0.616 l-40.74,13.029c-0.77,0.246-1.528,0.305-2.255,0.177c-1.34-0.236-2.566-1.112-3.281-2.344c-0.485-0.835-0.934-2.19-0.321-3.9 l14.44-40.261c2.117-5.903,1.194-12.465-2.468-17.555l-24.98-34.72c-1.541-2.141-0.748-4.177-0.335-4.953 c0.413-0.776,1.657-2.572,4.293-2.493l42.753,1.292c6.267,0.19,12.224-2.715,15.934-7.772l25.302-34.487 c1.56-2.127,3.741-2.002,4.607-1.849c0.865,0.152,2.958,0.781,3.697,3.313l11.983,41.06c1.757,6.02,6.362,10.787,12.316,12.752 l40.617,13.407c2.505,0.826,3.06,2.94,3.182,3.81c0.122,0.87,0.171,3.055-2.009,4.54l-35.347,24.085 c-5.182,3.531-8.293,9.382-8.323,15.653l-0.199,42.772c-0.008,1.816-0.894,2.935-1.635,3.555 C3089.545,737.752,3088.093,738.156,3086.753,737.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "#FFFFFF"
    },
    d: "M3009.099,665.409c-0.447-0.079-0.812-0.437-0.878-0.91 c-0.565-4.021-2.118-7.888-4.49-11.185l-9.504-13.209c-0.347-0.482-0.237-1.154,0.245-1.502c0.482-0.347,1.155-0.237,1.502,0.245 l9.504,13.209c2.575,3.579,4.26,7.778,4.874,12.143c0.083,0.588-0.327,1.132-0.916,1.215 C3009.321,665.431,3009.208,665.428,3009.099,665.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "#FFFFFF"
    },
    d: "M3025.583,703.7c-0.381-0.067-0.713-0.338-0.839-0.732 c-0.181-0.566,0.131-1.172,0.697-1.353l5.454-1.744c4.198-1.343,8.712-1.648,13.053-0.882c4.341,0.765,8.479,2.596,11.966,5.294 c0.47,0.364,0.556,1.04,0.192,1.509c-0.364,0.47-1.039,0.556-1.509,0.193c-3.212-2.485-7.024-4.171-11.023-4.876 c-3.999-0.705-8.157-0.424-12.025,0.813l-5.454,1.744C3025.925,703.72,3025.749,703.729,3025.583,703.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.76,
      fill: "#FFFFFF"
    },
    d: "M3075.984,721.271c-0.831-0.147-1.647-0.417-2.423-0.812 c-0.529-0.27-0.74-0.918-0.471-1.447c0.27-0.53,0.917-0.741,1.448-0.471c2.031,1.034,4.433,0.927,6.424-0.288 c1.996-1.217,3.147-3.263,3.158-5.615l0.103-22.165c0.042-8.986,4.501-17.372,11.927-22.432l18.317-12.481 c2.13-1.451,3.188-3.842,2.829-6.394c-0.359-2.553-2.034-4.559-4.482-5.367l-21.048-6.947 c-8.534-2.816-15.132-9.647-17.649-18.275l-6.209-21.277c-0.722-2.475-2.669-4.219-5.208-4.667 c-2.539-0.448-4.965,0.526-6.49,2.605l-13.111,17.871c-5.316,7.246-13.852,11.41-22.834,11.138l-22.155-0.669 c-1.321-0.04-2.592,0.293-3.674,0.963c-0.506,0.313-1.168,0.156-1.481-0.349c-0.313-0.506-0.156-1.169,0.349-1.481 c1.442-0.893,3.127-1.336,4.871-1.284l22.155,0.669c8.274,0.25,16.137-3.585,21.034-10.26l13.112-17.871 c1.99-2.713,5.284-4.035,8.598-3.451c3.313,0.584,5.957,2.953,6.9,6.183l6.209,21.277c2.319,7.947,8.397,14.24,16.258,16.834 l21.047,6.947c3.195,1.054,5.47,3.779,5.939,7.111c0.468,3.332-0.968,6.579-3.749,8.473l-18.317,12.481 c-6.841,4.661-10.948,12.385-10.987,20.663l-0.103,22.165c-0.014,3.069-1.581,5.851-4.19,7.442 C3080.204,721.235,3078.047,721.634,3075.984,721.271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021827427896308012300000015174640928366687912_",
    gradientUnits: "userSpaceOnUse",
    x1: -147.6744,
    y1: 3599.7563,
    x2: -967.4286,
    y2: 4676.4805,
    gradientTransform: "matrix(0.9756 0.2197 -0.2197 0.9756 3201.2285 -2769.5083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021827427896308012300000015174640928366687912_)"
    },
    d: "M1696.17,565.359l504.533,113.59 c27.836,6.267,45.876,33.247,41.033,61.364l-127.442,739.865c-3.79,22.002-25.046,36.496-46.913,31.989l-580.625-119.678 c-20.547-4.236-33.625-24.501-29.017-44.967l165.743-736.19C1630.861,578.565,1663.404,557.982,1696.17,565.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1574.384,1401.072c-0.26,0-0.524-0.03-0.787-0.092l-64.516-15.405 c-22.607-5.396-36.847-28.235-31.742-50.913l21.995-97.692c0.408-1.818,2.213-2.954,4.031-2.549 c1.818,0.408,2.957,2.213,2.549,4.031l-21.995,97.692c-4.298,19.095,7.693,38.327,26.73,42.872l64.516,15.405 c1.811,0.433,2.928,2.253,2.496,4.064C1577.292,1400.032,1575.909,1401.072,1574.384,1401.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1509.44,1210.824c-0.247,0-0.494-0.026-0.744-0.082c-1.818-0.408-2.957-2.213-2.549-4.031 l3.56-15.82c0.408-1.819,2.21-2.956,4.031-2.549c1.818,0.408,2.957,2.213,2.549,4.031l-3.56,15.82 C1512.374,1209.76,1510.981,1210.824,1509.44,1210.824z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1699.057,559.78c66.795,24.855,297.214,107.093,496.485,136.157 c9.089,1.326,15.317,9.839,13.778,18.894l-126.368,743.531c-1.733,10.195-11.365,17.078-21.57,15.406 c-83.484-13.672-427.019-71.212-545.187-111.134c-7.191-2.43-11.386-9.89-9.761-17.305l169.207-772.761 C1677.94,562.07,1688.985,556.033,1699.057,559.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1702.146,580.5c64.279,23.919,286.02,103.06,477.789,131.03 c8.745,1.276,14.74,9.468,13.258,18.182l-121.609,715.534c-1.667,9.811-10.938,16.434-20.759,14.826 c-80.339-13.158-410.939-68.532-524.655-106.95c-6.922-2.338-10.959-9.517-9.396-16.654l162.837-743.662 C1681.824,582.705,1692.453,576.894,1702.146,580.5z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2133.656,766.171c7.238,1.629,13.607,0.659,14.155-2.156c0.548-2.815-4.901-6.557-12.109-8.316 l-166.8-40.689c-7.207-1.758-12.715,0.112-12.239,4.156c0.476,4.044,6.787,8.686,14.025,10.315L2133.656,766.171z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1962.54,743.271c-7.207-1.758-12.715,0.112-12.239,4.155 c0.476,4.044,6.787,8.685,14.025,10.315l162.968,36.691c7.238,1.629,13.607,0.659,14.155-2.156 c0.548-2.815-4.901-6.557-12.109-8.315L1962.54,743.271z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1956.085,771.942c-7.207-1.758-12.715,0.112-12.239,4.155 c0.476,4.044,6.787,8.685,14.025,10.315l162.967,36.69c7.238,1.63,13.608,0.659,14.156-2.156 c0.548-2.815-4.901-6.557-12.108-8.316L1956.085,771.942z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2125.185,886.274c7.238,1.63,13.523,0.64,13.969-2.198s-5.102-6.541-12.326-8.227 l-411.071-95.958c-7.224-1.686-11.385,0.548-9.245,4.966c2.14,4.418,9.812,9.366,17.05,10.995L2125.185,886.274z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1709.394,808.15c-7.224-1.687-11.385,0.549-9.245,4.967c2.14,4.418,9.812,9.366,17.05,10.996 l401.625,90.422c7.238,1.63,13.523,0.64,13.969-2.198c0.445-2.839-5.102-6.541-12.326-8.227L1709.394,808.15z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1762.059,887.126c-1.793-1.1-3.796-1.885-5.98-2.292c-0.077-0.051-0.147-0.036-0.224-0.086 c-1.757-0.296-3.788-0.6-5.958-0.94c-10.712-1.603-25.681-3.162-39.179-4.499c-7.421-0.826-14.149-1.532-19.008-2.103 c-3.557-0.447-7.07,0.52-9.722,2.653c-2.358,1.933-3.757,4.539-3.993,7.503l-4.141,48.916 c-0.653,7.593,5.057,14.547,13.27,16.219l57.076,11.447c0.014,0.065,0.078,0.051,0.14,0.037 c7.982,1.518,15.722-3.075,17.265-10.317c4.822-22.111,9.115-42.886,8.226-54.477 C1769.484,894.183,1766.492,889.754,1762.059,887.126z M1765.091,899.539c0.819,10.93-3.344,31.39-8.097,53.146 c-0.999,4.754-6.749,5.717-11.732,6.799c0,0-0.063,0.014-0.126,0.027l-57.038-11.575c-5.889-1.227-9.971-6.022-9.54-11.195 l4.197-48.993c0.112-1.649,0.888-3.069,2.274-4.183c1.615-1.301,3.776-1.954,6.079-1.641c4.928,0.555,11.658,1.305,19.15,2.115 c11.909,1.208,25.972,2.647,36.578,4.068c3.082,0.483,5.814,0.916,8.216,1.344c1.96,0.318,3.817,1.073,5.358,2.228 C1763.063,893.607,1764.837,896.479,1765.091,899.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1696.323,887.901c12.165,1.478,38.773,3.822,51.182,6.037 c5.258,0.938,9.252,4.987,9.612,9.77c0.698,9.292-2.988,26.839-6.512,43.012c-1.055,4.843-6.269,7.873-11.718,6.776 l-45.598-9.18c-5.607-1.129-9.538-5.852-9.107-10.941l3.318-39.097C1687.843,890.233,1691.812,887.353,1696.323,887.901z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1812.561,925.667c-7.251-1.567-12.767,3.206-12.257,10.607l0.213,3.095 c0.51,7.401,6.889,14.597,14.176,15.992l270.725,51.805c7.287,1.394,14.062-2.283,15.055-8.172 c0.994-5.889-4.126-11.989-11.377-13.557L1812.561,925.667z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079458231065009032340000008677747681612675257_",
    gradientUnits: "userSpaceOnUse",
    x1: 9647.8818,
    y1: -5633.9922,
    x2: 9267.9346,
    y2: -5281.0239,
    gradientTransform: "matrix(0.9821 0.188 -0.188 0.9821 3176.6401 -2876.0037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079458231065009032340000008677747681612675257_)"
    },
    d: "M1697.317,895.888L1697.317,895.888 c4.721-1.678,9.898,0.853,11.472,5.609l7.408,22.37c0.742,2.239,3.719,2.676,5.072,0.745l39.88-56.909 c1.99-2.839,6.413-0.903,5.711,2.49c-3.93,18.991-15.91,54.223-52.137,78.703c0,0-15.522-9.728-23.352-41.966 C1690.24,902.272,1692.801,897.494,1697.317,895.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1738.615,1009.654c-1.799-1.099-3.795-1.885-5.987-2.289c-0.077-0.051-0.14-0.038-0.218-0.089 c-1.757-0.295-3.787-0.6-5.964-0.94c-10.774-1.587-25.674-3.161-39.186-4.563c-7.414-0.762-14.135-1.468-19.001-2.037 c-3.55-0.448-7.064,0.517-9.716,2.65c-2.358,1.934-3.756,4.541-4.006,7.441l-4.127,48.981 c-0.674,7.529,5.05,14.548,13.269,16.218l57.077,11.448c0.063-0.014,0.077,0.051,0.14,0.037 c7.982,1.517,15.722-3.075,17.265-10.318c4.816-22.109,9.109-42.884,8.204-54.54 C1746.026,1016.646,1743.034,1012.217,1738.615,1009.654z M1741.647,1022.066c0.819,10.929-3.354,31.34-8.108,53.097 c-1.005,4.756-6.316,7.738-11.757,6.683c0,0-0.07,0.015-0.084-0.05l-57.07-11.448c-5.874-1.162-9.965-5.964-9.528-11.138 l4.204-48.931c0.118-1.649,0.887-3.104,2.272-4.217c1.609-1.298,3.849-1.92,6.069-1.656c4.95,0.618,11.67,1.327,19.162,2.137 c11.909,1.208,25.981,2.69,36.581,4.114c3.087,0.481,5.881,0.89,8.212,1.331c1.967,0.319,3.76,1.08,5.28,2.173 C1739.536,1016.091,1741.392,1019.006,1741.647,1022.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1672.877,1010.42c12.166,1.477,38.775,3.821,51.182,6.036 c5.259,0.938,9.251,4.988,9.612,9.772c0.699,9.291-2.987,26.838-6.511,43.01c-1.057,4.845-6.27,7.874-11.719,6.778 l-45.598-9.181c-5.608-1.129-9.538-5.851-9.107-10.94l3.319-39.098C1664.398,1012.753,1668.366,1009.873,1672.877,1010.42z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1789.116,1048.186c-7.251-1.567-12.767,3.206-12.257,10.607l0.213,3.096 c0.51,7.401,6.889,14.598,14.176,15.992l270.726,51.805c7.287,1.394,14.062-2.283,15.055-8.172s-4.126-11.99-11.377-13.557 L1789.116,1048.186z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058591410394688926310000010716328616500104613_",
    gradientUnits: "userSpaceOnUse",
    x1: 9710.0811,
    y1: -5567.0176,
    x2: 9330.1348,
    y2: -5214.0498,
    gradientTransform: "matrix(0.9821 0.188 -0.188 0.9821 3176.6401 -2876.0037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058591410394688926310000010716328616500104613_)"
    },
    d: "M1673.871,1018.408L1673.871,1018.408 c4.72-1.68,9.898,0.852,11.473,5.609l7.407,22.369c0.741,2.24,3.717,2.677,5.072,0.745l39.881-56.91 c1.989-2.839,6.414-0.903,5.711,2.491c-3.929,18.989-15.91,54.224-52.139,78.702c0,0-15.521-9.727-23.35-41.967 C1666.794,1024.791,1669.356,1020.012,1673.871,1018.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1710.791,1126.359c-1.877-1.15-3.956-1.985-6.224-2.44c-1.821-0.282-3.802-0.665-6.021-0.928 c-10.922-1.625-26.303-3.229-39.123-4.576c-7.414-0.762-14.135-1.469-19.078-2.089c-3.472-0.398-7.056,0.583-9.645,2.703 c-2.365,1.867-3.75,4.539-4.006,7.439l-4.141,48.917c-0.654,7.592,5.057,14.547,13.276,16.215l57.085,11.515 c0,0,0.062-0.014,0.146,0.035c7.982,1.518,15.721-3.074,17.264-10.318c4.816-22.108,9.094-42.949,8.205-54.539 C1718.196,1133.352,1715.154,1129.001,1710.791,1126.359z M1713.795,1138.643c0.826,10.995-3.34,31.406-8.101,53.162 c-1.061,4.769-6.485,7.572-11.897,6.647l-57.007-11.462c-5.889-1.229-9.98-6.028-9.549-11.201l4.148-48.919 c0.126-1.585,0.95-3.118,2.28-4.151c1.602-1.365,3.849-1.92,6.138-1.671c4.88,0.634,11.664,1.328,19.078,2.088 c11.923,1.272,26.058,2.741,36.602,4.177c3.067,0.417,5.867,0.824,8.199,1.267c1.96,0.318,3.83,1.132,5.434,2.274 C1711.776,1132.782,1713.534,1135.584,1713.795,1138.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1645.015,1127.043c12.166,1.478,38.775,3.823,51.184,6.037 c5.257,0.939,9.251,4.987,9.61,9.772c0.699,9.291-2.987,26.838-6.511,43.011c-1.056,4.844-6.27,7.872-11.717,6.775l-45.6-9.18 c-5.607-1.128-9.538-5.851-9.105-10.94l3.318-39.097C1636.537,1129.376,1640.505,1126.497,1645.015,1127.043z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1761.254,1164.811c-7.251-1.567-12.767,3.206-12.257,10.607l0.213,3.095 c0.51,7.401,6.889,14.598,14.176,15.992l270.725,51.805c7.287,1.394,14.062-2.283,15.055-8.172s-4.126-11.99-11.377-13.557 L1761.254,1164.811z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047765892176742899330000014286038428014599569_",
    gradientUnits: "userSpaceOnUse",
    x1: 9767.3037,
    y1: -5505.438,
    x2: 9387.3574,
    y2: -5152.4702,
    gradientTransform: "matrix(0.9821 0.188 -0.188 0.9821 3176.6401 -2876.0037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047765892176742899330000014286038428014599569_)"
    },
    d: "M1646.01,1135.031L1646.01,1135.031 c4.72-1.678,9.898,0.853,11.473,5.608l7.408,22.369c0.741,2.241,3.718,2.677,5.072,0.745l39.88-56.909 c1.989-2.839,6.413-0.905,5.71,2.49c-3.929,18.99-15.909,54.224-52.138,78.702c0,0-15.522-9.727-23.352-41.965 C1638.933,1141.415,1641.495,1136.637,1646.01,1135.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1681.122,1246.444c-1.877-1.15-3.95-1.986-6.281-2.427c-1.828-0.281-3.872-0.651-6.029-0.927 c-10.711-1.603-25.61-3.176-39.06-4.592c-7.477-0.745-14.198-1.454-19.078-2.088c-3.549-0.447-7.05,0.583-9.702,2.717 c-2.308,1.856-3.756,4.541-4.006,7.439l-4.148,48.919c-0.653,7.591,5.056,14.545,13.277,16.216l57.083,11.512 c0.07-0.015,0.07-0.015,0.147,0.036c7.981,1.518,15.708-3.139,17.313-10.396c4.831-22.043,9.046-42.871,8.156-54.462 C1688.456,1253.385,1685.485,1249.087,1681.122,1246.444z M1684.063,1258.743c0.827,10.995-3.34,31.405-8.101,53.161 c-1.012,4.691-6.246,7.724-11.75,6.683c-0.014-0.065-0.083-0.049-0.083-0.049l-57.084-11.514 c-5.874-1.162-9.966-5.963-9.528-11.137l4.205-48.932c0.132-1.586,0.95-3.118,2.286-4.154c1.596-1.362,3.849-1.918,6.069-1.655 c4.928,0.553,11.671,1.325,19.147,2.073c11.923,1.27,25.995,2.754,36.596,4.178c3.072,0.416,5.803,0.84,8.198,1.267 c1.981,0.382,3.851,1.196,5.371,2.288C1682.044,1252.883,1683.802,1255.683,1684.063,1258.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1615.305,1247.125c12.167,1.478,38.775,3.822,51.183,6.037 c5.258,0.939,9.252,4.988,9.611,9.772c0.7,9.29-2.987,26.839-6.512,43.01c-1.055,4.843-6.268,7.874-11.716,6.777l-45.599-9.18 c-5.607-1.13-9.539-5.852-9.107-10.941l3.318-39.097C1606.827,1249.458,1610.796,1246.578,1615.305,1247.125z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1731.544,1284.892c-7.251-1.567-12.767,3.206-12.257,10.607l0.213,3.094 c0.51,7.401,6.889,14.598,14.176,15.992l270.725,51.805c7.286,1.394,14.061-2.283,15.055-8.172 c0.994-5.889-4.126-11.989-11.377-13.557L1731.544,1284.892z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159466332337889198660000014878768484274377663_",
    gradientUnits: "userSpaceOnUse",
    x1: 9825.8428,
    y1: -5442.4209,
    x2: 9445.8965,
    y2: -5089.4531,
    gradientTransform: "matrix(0.9821 0.188 -0.188 0.9821 3176.6401 -2876.0037)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159466332337889198660000014878768484274377663_)"
    },
    d: "M1616.299,1255.113L1616.299,1255.113 c4.72-1.677,9.898,0.853,11.473,5.609l7.408,22.369c0.741,2.24,3.719,2.676,5.072,0.744l39.88-56.91 c1.99-2.838,6.413-0.903,5.711,2.491c-3.93,18.99-15.91,54.223-52.138,78.703c0,0-15.522-9.728-23.352-41.966 C1609.223,1261.497,1611.785,1256.718,1616.299,1255.113z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008836101441650494350000011160845310091064223_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.8463,
    y1: 2387.9814,
    x2: -32.0882,
    y2: 2698.3477,
    gradientTransform: "matrix(0.8405 0.5417 -0.5417 0.8405 3222.1831 -1608.2631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008836101441650494350000011160845310091064223_)"
    },
    d: "M2002.178,529.479 c-15.355-16.779-31.249-20.101-43.143-19.347c-10.878,0.735-19.695,9.085-21.094,19.818l-6.103,47.04l-0.885,6.558l56.051,17.968 c0,0,3.485-2.992,7.865-8.074C2006.313,580.325,2024,553.255,2002.178,529.479z M1956.434,548.69 c1.745-7.896,9.604-12.853,17.439-11.101c7.906,1.805,12.852,9.604,11.114,17.5c-1.808,7.909-9.604,12.852-17.516,11.05 C1959.58,564.396,1954.619,556.535,1956.434,548.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1985.372,521.617c-6.982-3.158-14.313-4.479-21.796-4.005 c-11.026,0.701-20.078,9.235-21.493,20.176l-0.829,6.479c-0.146,1.182,0.365,2.29,1.29,2.835c0.33,0.268,0.762,0.375,1.176,0.421 c1.618,0.259,3.066-0.868,3.261-2.468l0.892-6.493c1.059-8.221,7.797-14.628,16.084-15.141c6.546-0.404,12.953,0.71,19.03,3.452 c1.443,0.704,3.2,0.052,3.822-1.438C1987.515,523.996,1986.793,522.255,1985.372,521.617z M1943.435,549.955 c-1.597-0.196-3.045,0.932-3.24,2.532l-1.135,8.509c-0.147,1.184,0.351,2.228,1.297,2.833c0.392,0.254,0.757,0.378,1.176,0.422 c1.611,0.26,3.059-0.867,3.255-2.467l1.121-8.574C1946.181,551.662,1945.038,550.149,1943.435,549.955z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144307401654662523180000000251583990643428279_",
    gradientUnits: "userSpaceOnUse",
    x1: -361.1764,
    y1: 3424.3237,
    x2: -599.0575,
    y2: 3737.2507,
    gradientTransform: "matrix(0.9756 0.2197 -0.2197 0.9756 3201.2285 -2769.5083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144307401654662523180000000251583990643428279_)"
    },
    d: "M1845.163,599.919l5.943-26.4 c2.052-9.113,11.248-14.712,20.286-12.349l180.61,47.214c8.016,2.095,13.123,9.945,11.79,18.121l-4.19,25.71L1845.163,599.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1912.843,579.503l7.828,1.762L1912.843,579.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1855.617,594.909c-0.995-0.642-1.535-1.857-1.26-3.082l2.404-10.68 c0.987-4.385,3.621-8.122,7.422-10.526c3.799-2.403,8.307-3.184,12.694-2.198l28.778,6.48c1.557,0.355,2.55,1.907,2.195,3.475 c-0.352,1.566-1.907,2.549-3.475,2.198l-28.777-6.481c-5.926-1.334-11.833,2.402-13.166,8.329l-2.406,10.68 c-0.352,1.565-1.907,2.548-3.474,2.197C1856.211,595.224,1855.896,595.089,1855.617,594.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1790.306,577.416l318.289,71.651c11.444,2.576,19.375,13.014,18.788,24.731l-0.081,1.616 c-0.643,12.834-12.697,21.991-25.232,19.168l-326.544-73.517c-7.503-1.689-12.069-9.307-10.022-16.72l3.994-14.457 C1771.996,580.845,1781.154,575.356,1790.306,577.416z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081612109360821735580000006925985062722474406_",
    gradientUnits: "userSpaceOnUse",
    x1: 2027.2903,
    y1: 3364.3547,
    x2: 3068.4998,
    y2: 2333.4019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081612109360821735580000006925985062722474406_)"
    },
    d: "M3240.757,3210.955h-703.749V1820.284 c0-11.573,9.382-20.954,20.954-20.954h661.841c11.573,0,20.954,9.381,20.954,20.954V3210.955z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142879171485429985680000005018125977391965609_",
    gradientUnits: "userSpaceOnUse",
    x1: 3229.5515,
    y1: 1841.2527,
    x2: 2093.0095,
    y2: 3658.6951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142879171485429985680000005018125977391965609_)"
    },
    d: "M3161.59,3210.955h-703.749V1820.284 c0-11.573,9.381-20.954,20.954-20.954h661.841c11.573,0,20.954,9.381,20.954,20.954V3210.955z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075154557280716034530000000103941118061266325_",
    gradientUnits: "userSpaceOnUse",
    x1: 948.6736,
    y1: 3246.4375,
    x2: 1525.658,
    y2: 2742.2251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075154557280716034530000000103941118061266325_)"
    },
    d: "M1570.259,3209.93h-518.997v-550.307 c0-11.573,9.381-20.954,20.954-20.954h477.089c11.573,0,20.954,9.381,20.954,20.954V3209.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145777260963383940230000013518834720482718888_",
    gradientUnits: "userSpaceOnUse",
    x1: 1544.7086,
    y1: 2455.6465,
    x2: 545.1073,
    y2: 3982.2085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145777260963383940230000013518834720482718888_)"
    },
    d: "M1492.517,3209.93H973.521v-550.307 c0-11.573,9.381-20.954,20.954-20.954h477.089c11.573,0,20.954,9.381,20.954,20.954V3209.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005958194610159313310000006180577838359728569_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7453,
    y1: 1778.6797,
    x2: 121.9804,
    y2: 1778.6797,
    gradientTransform: "matrix(-1 0 0 1 2861.6616 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005958194610159313310000006180577838359728569_)"
    },
    d: "M2739.683,1802.215 c-0.009-0.529,0.027-1.064,0.162-1.604c7.997-31.707,40.698-47.959,40.698-47.959l15.73,1.233 c9.044,27.946,14.875,41.588,13.423,49.223c-0.04,0.214-0.105,0.417-0.162,0.624 C2796.558,1804.891,2769.851,1805.648,2739.683,1802.215z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090277455622373854040000015443942286816342403_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.7352,
    y1: 1693.1643,
    x2: -29.5892,
    y2: 1896.0012,
    gradientTransform: "matrix(-1 0 0 1 2861.6616 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090277455622373854040000015443942286816342403_)"
    },
    d: "M2809.533,1803.732 c-0.701,2.549-2.583,4.534-4.991,5.04c-18.457,3.882-47.793,0.758-60.111-0.852c-2.717-0.355-4.704-2.868-4.748-5.705 C2769.851,1805.648,2796.558,1804.891,2809.533,1803.732z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109738030481601418210000000761818284135591333_",
    gradientUnits: "userSpaceOnUse",
    x1: 4598.7046,
    y1: 1696.2643,
    x2: 4584.6831,
    y2: 1818.6371,
    gradientTransform: "matrix(1 0 0 1 -1811.8352 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109738030481601418210000000761818284135591333_)"
    },
    d: "M2767.591,1728.174l6.887,33.153 c0.505,2.429,2.371,4.248,4.633,4.461c2.768,0.26,6.707,0.412,10.669-0.17c3.553-0.522,6.027-4.132,5.397-8.007l-4.787-29.437 H2767.591z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124135084944433597990000016946673357640230329_",
    gradientUnits: "userSpaceOnUse",
    x1: 4774.6694,
    y1: 1811.5457,
    x2: 4774.6694,
    y2: 1861.7938,
    gradientTransform: "matrix(1 0 0 1 -1811.8352 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124135084944433597990000016946673357640230329_)"
    },
    d: "M2943.181,1803.457 c-16.799-0.47-25.488-2.449-29.98-4.285c-0.01,1.671-0.001,3.37,0.053,5.132c0.059,1.881,1.452,3.384,3.166,3.373l92.237-0.596 c2.944-0.019,4.664-3.432,3.388-6.132C2999.951,1801.948,2969.149,1804.184,2943.181,1803.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174574940219623444050000017355259529342385319_",
    gradientUnits: "userSpaceOnUse",
    x1: 4725.0361,
    y1: 1779.678,
    x2: 4823.8799,
    y2: 1779.678,
    gradientTransform: "matrix(1 0 0 1 -1811.8352 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174574940219623444050000017355259529342385319_)"
    },
    d: "M3012.045,1800.949 c-0.111-0.234-0.207-0.474-0.365-0.695c-8.145-11.382-28.892-34.047-69.889-43.877l-19.667-0.62c0,0-8.757,15.221-8.923,43.416 c4.492,1.836,13.181,3.814,29.98,4.285C2969.149,1804.184,2999.951,1801.948,3012.045,1800.949z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165952352009359775370000013471879869367336117_",
    gradientUnits: "userSpaceOnUse",
    x1: 4746.4146,
    y1: 1711.9205,
    x2: 4733.2979,
    y2: 1826.3918,
    gradientTransform: "matrix(1 0 0 1 -1811.8352 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165952352009359775370000013471879869367336117_)"
    },
    d: "M2918.477,1725.95 c0.219,1.466,2.914,23.747,3.958,32.385c0.248,2.053,1.735,3.642,3.61,3.866c3.349,0.4,8.768,0.764,13.509-0.208 c2.557-0.524,4.409-2.981,4.409-5.838v-34.974L2918.477,1725.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054951514370807762120000008920937243924847547_",
    gradientUnits: "userSpaceOnUse",
    x1: 2853.6064,
    y1: 1708.2601,
    x2: 2869.3416,
    y2: 1215.2388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054951514370807762120000008920937243924847547_)"
    },
    d: "M2780.733,1292.825 c0,0-31.47,279.743-13.987,454.582c0,0,20.981,0,31.471-3.496c0,0,32.703-273.517,43.283-351.784 c0.399-2.951,4.611-3.085,5.19-0.164c13.053,65.847,64.322,324.066,70.418,348.452c0,0,17.484,6.993,31.471,0 c0,0-27.974-374.156-48.955-440.595L2780.733,1292.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016761504284159578980000014657454990895057030_",
    gradientUnits: "userSpaceOnUse",
    x1: 2837.5854,
    y1: 931.4439,
    x2: 2822.3682,
    y2: 1521.5487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016761504284159578980000014657454990895057030_)"
    },
    d: "M2717.791,967.624 c0,0,132.877-20.981,237.781,6.994l-6.994,108.4c0,0-27.974,150.362-48.955,216.801c0,0-80.426,13.987-118.891-6.994 c0,0-31.47-188.826-48.955-216.801C2731.778,1076.024,2714.294,1002.592,2717.791,967.624z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103232308290609263380000002383405043585080730_",
    gradientUnits: "userSpaceOnUse",
    x1: 2845.2336,
    y1: 1038.5271,
    x2: 2819.3806,
    y2: 895.7729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103232308290609263380000002383405043585080730_)"
    },
    d: "M2810.1,872.076l-13.238,89.518 c0,0,36.983,16.989,62.879-0.729l-5.575-63.176L2810.1,872.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016782834367387489130000008466626172848071553_",
    gradientUnits: "userSpaceOnUse",
    x1: 2683.051,
    y1: 927.4586,
    x2: 2667.8337,
    y2: 1517.5642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016782834367387489130000008466626172848071553_)"
    },
    d: "M2777.602,1088.367 c0,0-300.247-81.728-151.163-291.907l10.087,14.281c0,0-44.917,142.358,103.877,155.884 C2740.404,966.625,2778.941,1066.016,2777.602,1088.367z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057131792660174626740000000932648878559099539_",
    gradientUnits: "userSpaceOnUse",
    x1: 2663.408,
    y1: 733.723,
    x2: 2627.9001,
    y2: 850.3914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057131792660174626740000000932648878559099539_)"
    },
    d: "M2625.426,797.541 c0,0-3.382-40.581,16.909-43.962c20.29-3.382,27.053,16.908,30.435,27.053c3.382,10.145-30.435,30.435-37.199,30.435 C2628.808,811.068,2625.426,797.541,2625.426,797.541z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115488047759684238210000000857739397592781743_",
    gradientUnits: "userSpaceOnUse",
    x1: -1083.4377,
    y1: 937.6039,
    x2: -1098.6553,
    y2: 1527.7094,
    gradientTransform: "matrix(-1 0 0 1 1897.0294 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115488047759684238210000000857739397592781743_)"
    },
    d: "M2885.916,1098.512 c0,0,300.247-81.728,151.163-291.906l-10.087,14.281c0,0,44.917,142.358-103.877,155.885 C2923.115,976.771,2884.577,1076.161,2885.916,1098.512z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114057870736985136230000004412639217497777812_",
    gradientUnits: "userSpaceOnUse",
    x1: -1103.0812,
    y1: 743.8682,
    x2: -1138.5887,
    y2: 860.5361,
    gradientTransform: "matrix(-1 0 0 1 1897.0294 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114057870736985136230000004412639217497777812_)"
    },
    d: "M3038.092,807.685 c0,0,3.382-40.58-16.908-43.962c-20.29-3.382-27.054,16.909-30.436,27.054c-3.382,10.145,30.436,30.435,37.199,30.435 C3034.711,821.213,3038.092,807.685,3038.092,807.685z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134242308124925427480000012815019476067754684_",
    gradientUnits: "userSpaceOnUse",
    x1: -2809.3604,
    y1: -238.158,
    x2: -2840.0015,
    y2: -339.219,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134242308124925427480000012815019476067754684_)"
    },
    d: "M2856.247,825.655 c0,0,29.606,55.729,25.811,78.242c-3.795,22.512-40.487,20.896-72.528,2.612l-22.389-60.176L2856.247,825.655z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127028200632892324730000008966421489697545121_",
    gradientUnits: "userSpaceOnUse",
    x1: -2837.0044,
    y1: -414.2418,
    x2: -2811.3735,
    y2: -268.0507,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127028200632892324730000008966421489697545121_)"
    },
    d: "M2810.947,876.956 c1.302-0.576,1.783-2.17,1.003-3.362c-2.372-3.623-6.818-11.016-8.236-17.488c0,0-5.323-3.408,13.546-7.925 c18.868-4.516,47.006-11.526,52.921-27.587c5.766-15.659-9.385-55.037-33.556-23.661c-0.919,1.194-2.722,1.221-3.64,0.025 c-3.962-5.157-14.38-15.862-28.844-9.372c-13.535,6.073-15.06,15.991-14.874,20.99c0.055,1.471-1.26,2.614-2.706,2.338 c-6.844-1.305-23.265-2.426-30.93,14.42c-6.313,13.876-2.21,21.73,1.527,25.572c1.211,1.244,0.68,3.294-0.98,3.802 c-4.498,1.377-10.306,5.19-9.724,15.728c0.804,14.566,17.091,13.283,21.728,12.619c0.759-0.109,1.525,0.152,2.039,0.721 c3.976,4.4,21.889,23.082,41.277,25.334c1.679,0.195,2.98-1.463,2.43-3.061l-8.39-24.389c-0.39-1.133,0.152-2.376,1.248-2.861 L2810.947,876.956z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107559441806470852260000002175956724403376018_",
    gradientUnits: "userSpaceOnUse",
    x1: -2840.6829,
    y1: -238.6287,
    x2: -2868.251,
    y2: -329.555,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107559441806470852260000002175956724403376018_)"
    },
    d: "M2814.319,880.419 c0,0-21.08-14.463-22.62-2.284c-1.54,12.18,18.983,17.641,29.148,13.101L2814.319,880.419z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129170582382174493930000001749919800156832698_",
    gradientUnits: "userSpaceOnUse",
    x1: 1262.7008,
    y1: 3285.9763,
    x2: 2177.8711,
    y2: 2728.6162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129170582382174493930000001749919800156832698_)"
    },
    d: "M2362.295,3210.955h-597.06v-813.917 c0-11.573,9.381-20.954,20.954-20.954h555.152c11.572,0,20.954,9.381,20.954,20.954V3210.955z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093855514852347807220000002415523171953628062_",
    gradientUnits: "userSpaceOnUse",
    x1: 2323.4526,
    y1: 2324.4226,
    x2: 1449.9855,
    y2: 3521.1436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093855514852347807220000002415523171953628062_)"
    },
    d: "M2274.444,3210.955h-597.06v-813.917 c0-11.573,9.381-20.954,20.954-20.954h555.152c11.573,0,20.954,9.381,20.954,20.954V3210.955z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099627554426911741870000012481478111500490374_",
    gradientUnits: "userSpaceOnUse",
    x1: 2034.3169,
    y1: 2083.979,
    x2: 1754.871,
    y2: 1929.9659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099627554426911741870000012481478111500490374_)"
    },
    d: "M1988.296,1991.871l-45.807,70.47 c21.309,41.514,44.978,64.432,68.657,75.327c4.228-25.864,19.333-47.333,30.424-60.085 C1999.328,2053.556,1988.296,1991.871,1988.296,1991.871z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161620060891245942600000009238385451174371230_",
    gradientUnits: "userSpaceOnUse",
    x1: 2179.9626,
    y1: 2052.1819,
    x2: 1835.8152,
    y2: 2218.897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161620060891245942600000009238385451174371230_)"
    },
    d: "M2145.678,2064.932 c-46.898,27.758-80.414,26.129-104.108,12.651c-11.09,12.752-26.196,34.221-30.424,60.085 c75.275,34.634,150.654-52.539,150.654-52.539L2145.678,2064.932z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101814861152721834870000004671270233300781203_",
    gradientUnits: "userSpaceOnUse",
    x1: 2181.604,
    y1: 2055.5706,
    x2: 1837.4579,
    y2: 2222.2849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101814861152721834870000004671270233300781203_)"
    },
    d: "M2148.23,2077.004 c0,0-12.66-22.073,5.547-39.021c0,0,5.871-6.697,12.317,3.142c0,0,19.587-17.782,24.943-10.619 c5.357,7.163,19.555,24.898,5.688,45.127C2182.701,2096.092,2154.415,2086.973,2148.23,2077.004z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158013579455682875220000018096645232505422524_",
    gradientUnits: "userSpaceOnUse",
    x1: 2089.5703,
    y1: 2201.7805,
    x2: 2155.8894,
    y2: 2078.1345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158013579455682875220000018096645232505422524_)"
    },
    d: "M2167.476,2065.791 c-2.035,0-4.232-0.38-6.191-1.539c-1.933-1.148-4.37-3.522-4.982-8.323c-0.234-1.847,1.073-3.537,2.921-3.772 c1.877-0.227,3.534,1.073,3.771,2.919c0.323,2.532,1.373,3.162,1.719,3.367c1.133,0.678,2.796,0.697,4.284,0.491l-4.067-12.894 c-0.56-1.777,0.428-3.67,2.203-4.23c1.778-0.565,3.672,0.425,4.232,2.201l5.14,16.299c0.53,1.689-0.336,3.504-1.982,4.153 C2174.019,2064.66,2170.989,2065.791,2167.476,2065.791z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083058403776113905380000002639063094826875271_",
    gradientUnits: "userSpaceOnUse",
    x1: 1267.4561,
    y1: 2539.157,
    x2: 1362.7744,
    y2: 2562.5002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083058403776113905380000002639063094826875271_)"
    },
    d: "M1481.922,2538.198 c-4.076,2.453-6.159,7.621-5.188,12.684c3.823,19.926,16.391,72.557,46.92,103.716c2.016,2.057,4.949,1.875,6.722,0.02 c-7.73-8.053-17.315-21.82-28.52-45.198C1484.635,2573.487,1481.446,2551.325,1481.922,2538.198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036248721914194827790000007569216057399911335_",
    gradientUnits: "userSpaceOnUse",
    x1: 1481.8778,
    y1: 2593.7498,
    x2: 1539.2111,
    y2: 2593.7498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036248721914194827790000007569216057399911335_)"
    },
    d: "M1521.342,2537.454 c0,0-19.684-10.707-39.283,0.648c-0.049,0.028-0.089,0.067-0.137,0.096c-0.476,13.127,2.713,35.288,19.934,71.221 c11.205,23.379,20.79,37.145,28.52,45.198c0.561-0.587,1.012-1.333,1.273-2.239 C1537.384,2632.457,1549.492,2577.105,1521.342,2537.454z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162348180236523453600000012448933083776620188_",
    gradientUnits: "userSpaceOnUse",
    x1: 1510.5002,
    y1: 2535.7761,
    x2: 1552.6609,
    y2: 2535.7761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162348180236523453600000012448933083776620188_)"
    },
    d: "M1549.772,2538.693l-17.837,17.114 c-3.155,3.027-7.993,3.515-11.636,1.097c-3.178-2.109-6.715-5.568-9.07-11.174c-1.413-3.364-0.735-7.256,1.72-9.956 l17.808-19.589c4.25-4.675,11.813-3.902,15.028,1.537l5.568,9.418C1553.572,2530.892,1552.917,2535.676,1549.772,2538.693z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082357657464366079000000005449061435444044430_",
    gradientUnits: "userSpaceOnUse",
    x1: 2126.3027,
    y1: 2403.6924,
    x2: 2207.0693,
    y2: 2403.6924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082357657464366079000000005449061435444044430_)"
    },
    d: "M2126.303,2452.846 c4.147,2.331,9.669,1.588,13.59-1.759c15.432-13.172,54.975-50.11,66.973-92.049c0.792-2.769-0.817-5.229-3.305-5.853 c-3.181,10.7-10.41,25.837-25.197,47.132C2155.639,2433.047,2137.949,2446.773,2126.303,2452.846z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080185124672458852830000012886922436458099344_",
    gradientUnits: "userSpaceOnUse",
    x1: 2106.1721,
    y1: 2402.9373,
    x2: 2203.5608,
    y2: 2402.9373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080185124672458852830000012886922436458099344_)"
    },
    d: "M2106.172,2418.945 c0,0,0.421,22.403,19.979,33.83c0.049,0.028,0.102,0.044,0.151,0.072c11.647-6.073,29.336-19.799,52.062-52.529 c14.786-21.295,22.016-36.432,25.197-47.132c-0.787-0.198-1.659-0.221-2.576,0 C2180.832,2358.046,2126.729,2374.877,2106.172,2418.945z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085234377516153787270000004290633251353448122_",
    gradientUnits: "userSpaceOnUse",
    x1: 2080.354,
    y1: 2400.1167,
    x2: 2126.6748,
    y2: 2400.1167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085234377516153787270000004290633251353448122_)"
    },
    d: "M2104.792,2381.848l18.639,16.237 c3.297,2.872,4.215,7.647,2.132,11.492c-1.816,3.353-4.946,7.185-10.319,10.031c-3.224,1.708-7.161,1.38-10.07-0.824 l-21.102-15.987c-5.036-3.816-4.941-11.417,0.188-15.105l8.883-6.388C2096.682,2378.76,2101.506,2378.985,2104.792,2381.848z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093855968057893014410000017164758667924104115_",
    gradientUnits: "userSpaceOnUse",
    x1: 1791.2583,
    y1: 2263.5667,
    x2: 1478.5028,
    y2: 2549.3218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093855968057893014410000017164758667924104115_)"
    },
    d: "M1730.826,2217.506 c0,0-36.37,123.903-59.884,178.361c0,0-41.105,6.271-66.545,21.135c-25.44,14.865-80.239,97.253-80.239,97.253 s14.311,27.168,31.578,31.336l155.998-108.088l124.5-144.784l-5.909-67.154L1730.826,2217.506z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137816381191082975670000007111354241521450897_",
    gradientUnits: "userSpaceOnUse",
    x1: 2209.9536,
    y1: 2317.811,
    x2: 1823.2794,
    y2: 2302.0745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137816381191082975670000007111354241521450897_)"
    },
    d: "M1733.067,2207.399l-10.643,33.93 c0,0,9.734,88.954,121.878,73.954c112.144-15,126.239-33.308,126.239-33.308s-9.735,56.813,112.89,125.12 c0,0,18.64-14.071,22.742-30.049l-85.933-141.635c-11.953-18.578-23.038-23.471-44.864-20.058 c-48.26,7.547-138.626,17.385-152.302,15.05L1733.067,2207.399z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166641786006979389850000008840937382042002310_",
    gradientUnits: "userSpaceOnUse",
    x1: 1853.5977,
    y1: 2005.4047,
    x2: 1599.5551,
    y2: 2410.2844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166641786006979389850000008840937382042002310_)"
    },
    d: "M1820.653,1955.095 c-32.681,1.662-84.34,17.197-117.71,47.918c10.257,11.322,26.039,29.732,37.803,47.916c10.512-9.869,25.607-18.089,46.861-23.353 c-18.37,68.659-40.084,134.073-66.545,194.878c-1.656,3.805,0.23,8.208,4.149,9.573c20.476,7.135,80.858,24.129,129.288-3.239 l107.371-153.744c11.548-16.534,19.138-35.502,22.186-55.438l4.24-27.735C1988.296,1991.871,1891.864,1951.474,1820.653,1955.095 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105411858405127541030000003312999885991712438_",
    gradientUnits: "userSpaceOnUse",
    x1: 1752.8679,
    y1: 2164.7188,
    x2: 1548.0468,
    y2: 1802.709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105411858405127541030000003312999885991712438_)"
    },
    d: "M1762.095,2187.75 c-4.667-10.304-20.643-19.932-28.268-24.068c-6.633-13.674-33.112-75.171,6.919-112.753 c-11.764-18.185-27.546-36.594-37.803-47.916c-38.501,35.446-52.596,91.126,14.92,169.089 c-3.685,19.202,8.339,41.562,14.841,44.696C1735.7,2218.24,1768.296,2201.445,1762.095,2187.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052824881701818778240000003589953346574702740_",
    gradientUnits: "userSpaceOnUse",
    x1: 1785.0901,
    y1: 1583.0669,
    x2: 1815.439,
    y2: 2146.209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052824881701818778240000003589953346574702740_)"
    },
    d: "M1793.816,2025.172l29.854-6.442 L1793.816,2025.172z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146484788952728125180000007104377126933705880_",
    gradientUnits: "userSpaceOnUse",
    x1: 1882.3464,
    y1: 2009.7933,
    x2: 1903.7813,
    y2: 1948.6646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146484788952728125180000007104377126933705880_)"
    },
    d: "M1893.179,1914.258l-28.051,54.906 c-1.711,3.349-1.202,7.398,1.311,10.197c6.793,7.566,22.835,19.854,50.74,11.047c3.077-0.971,5.291-3.676,5.759-6.868 l7.305-49.865L1893.179,1914.258z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106856255028677718400000006689612838961600666_",
    gradientUnits: "userSpaceOnUse",
    x1: -4182.6748,
    y1: -85.2184,
    x2: -4210.5522,
    y2: -177.1649,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106856255028677718400000006689612838961600666_)"
    },
    d: "M1935.015,1860.033 c0,0,26.936,50.703,23.483,71.186c-3.453,20.482-36.835,19.011-65.987,2.377l-20.37-54.749L1935.015,1860.033z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046317067683200089410000009628162216900969387_",
    gradientUnits: "userSpaceOnUse",
    x1: -4207.8257,
    y1: -245.422,
    x2: -4184.5063,
    y2: -112.4152,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046317067683200089410000009628162216900969387_)"
    },
    d: "M1893.8,1906.708 c1.185-0.525,1.622-1.974,0.912-3.059c-2.158-3.297-6.203-10.022-7.494-15.911c0,0-4.843-3.101,12.324-7.21 c17.167-4.109,42.767-10.487,48.148-25.099c5.246-14.247-8.538-50.074-30.53-21.528c-0.837,1.086-2.476,1.11-3.311,0.023 c-3.605-4.692-13.083-14.431-26.242-8.526c-12.314,5.525-13.701,14.548-13.533,19.097c0.05,1.338-1.146,2.378-2.461,2.127 c-6.226-1.188-21.167-2.208-28.141,13.119c-5.744,12.625-2.01,19.771,1.39,23.266c1.102,1.132,0.619,2.996-0.892,3.459 c-4.092,1.252-9.376,4.722-8.847,14.309c0.732,13.253,15.55,12.085,19.768,11.481c0.691-0.099,1.387,0.138,1.855,0.656 c3.618,4.003,19.916,21,37.555,23.049c1.528,0.177,2.711-1.331,2.211-2.785l-7.634-22.19c-0.355-1.031,0.139-2.162,1.135-2.602 L1893.8,1906.708z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011747839486223974720000011862553782251335049_",
    gradientUnits: "userSpaceOnUse",
    x1: -4211.1724,
    y1: -85.6461,
    x2: -4236.2544,
    y2: -168.3728,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011747839486223974720000011862553782251335049_)"
    },
    d: "M1896.868,1909.858 c0,0-19.179-13.159-20.58-2.078c-1.401,11.081,17.27,16.051,26.519,11.92L1896.868,1909.858z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078750224668023056230000001048042458539005119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1231.1515,
    y1: 2889.0942,
    x2: 1028.8215,
    y2: 3354.4521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078750224668023056230000001048042458539005119_)"
    },
    d: "M980.991,3115.672 c0,0-7.752,43.886-11.553,87.328c-1.485,16.979,11.604,31.721,28.633,32.429c57.853,2.41,181.603,7.095,226.008,5.115 c6.676-0.298,11.041-7.132,8.569-13.342l0,0c-2.071-5.203-6.063-9.409-11.15-11.747l-204.411-93.947L980.991,3115.672z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164497628753887624540000002115703174220811435_",
    gradientUnits: "userSpaceOnUse",
    x1: 974.6414,
    y1: 3115.4915,
    x2: 1041.1305,
    y2: 3115.4915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164497628753887624540000002115703174220811435_)"
    },
    d: "M974.641,3089.886l6.227,52.495 c0,0,35.808,16.668,60.262-2.103l-14.829-58.498L974.641,3089.886z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176030107234432634570000015854709367319694995_",
    gradientUnits: "userSpaceOnUse",
    x1: 816.9791,
    y1: 2607.0894,
    x2: 1036.8269,
    y2: 2607.0894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176030107234432634570000015854709367319694995_)"
    },
    d: "M979.322,2102.988 c-2.69,13.708-14.44,684.082,57.218,984.5c1.169,4.902-1.316,9.955-5.981,11.861c-10.992,4.491-32.537,10.994-58.359,11.861 c-7.997,0.269-15.167-4.931-17.423-12.606c-20.483-69.701-118.635-418.926-131.439-752.53c-14.307-372.769,0-12.692,0-12.692 l8.391-230.425L979.322,2102.988z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061439929279968399930000001710062174514054038_",
    gradientUnits: "userSpaceOnUse",
    x1: 965.5573,
    y1: 2773.6189,
    x2: 763.2277,
    y2: 3238.9761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061439929279968399930000001710062174514054038_)"
    },
    d: "M745.851,3138.567 c0,0-12.34,22.155-24.286,81.027c-2.157,10.633,5.272,20.808,16.068,21.87c19.103,1.878,48.512,4.292,72.068,4.131 c10.86-0.075,19.335-9.531,18.027-20.312c-2.609-21.489-10.738-56.745-35.851-84.223L745.851,3138.567z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164502817827972771240000009312006805762947715_",
    gradientUnits: "userSpaceOnUse",
    x1: 735.0139,
    y1: 3112.0803,
    x2: 792.4206,
    y2: 3112.0803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164502817827972771240000009312006805762947715_)"
    },
    d: "M735.014,3071.048l14.553,79.384 c0,0,14.388,10.703,42.854,2.945l-6.946-85.414L735.014,3071.048z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031905497983480435700000006816322133849411229_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.1364,
    y1: 2599.8953,
    x2: 985.2502,
    y2: 2599.8953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031905497983480435700000006816322133849411229_)"
    },
    d: "M695.698,2123.559 c-58.607,353.695,12.713,874.186,36.766,976.06c1.472,6.236,6.507,11.014,12.828,12.062c10.735,1.78,28.413,3.232,45.839-1.829 c6.004-1.744,10.223-7.16,10.468-13.408c3.226-82.361-2.581-587.978,52.027-787.8c2.768-10.126,8.952-18.958,17.508-25.041 l105.99-75.35l8.127-121.798L695.698,2123.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121982854033076996500000004156228369909565363_",
    gradientUnits: "userSpaceOnUse",
    x1: 584.383,
    y1: 2001.3274,
    x2: 1630.6028,
    y2: 1248.3982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121982854033076996500000004156228369909565363_)"
    },
    d: "M1069.141,1453.375 c-175.633-2.902-369.425,46.116-369.425,46.116c-52.352,305.476-9.154,657.819-9.154,657.819 c135.971,35.657,289.354-21.801,289.354-21.801c22.599-127.682,128.04-487.019,128.04-487.019 c85.814-10.651,156.506-35.408,214.722-68.141c-44.406-51.473-65.34-116.969-74.433-155.686 C1186.148,1443.963,1123.313,1454.27,1069.141,1453.375z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173139459536023976950000010285268411781901487_",
    gradientUnits: "userSpaceOnUse",
    x1: 1204.8047,
    y1: 1575.4753,
    x2: 1656.6725,
    y2: 1197.7946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173139459536023976950000010285268411781901487_)"
    },
    d: "M1587.929,1194.678 c-17.253-20.839-39.088-10.981-39.088-10.981c-25.847,109.176-161.367,197.698-300.595,240.967 c9.093,38.717,30.026,104.213,74.433,155.686C1553.739,1450.433,1587.929,1194.678,1587.929,1194.678z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103950294798027128380000015987495670081403561_",
    gradientUnits: "userSpaceOnUse",
    x1: 1496.4292,
    y1: 1273.4701,
    x2: 1656.045,
    y2: 1053.1549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103950294798027128380000015987495670081403561_)"
    },
    d: "M1583.741,1199.977 c1.805,5.738-19.1,14.478-31.409-8.995c-0.43-11.25-7.272-59.445-0.55-68.609c35.802-48.81,105.215-109.996,105.215-109.996 c11.73,11.575,2.065,22.947,2.065,22.947l-33.672,35.078c7.043,12.728,15.635,23.471,19.66,38.867 c3.05,11.658,1.183,24.117-4.705,34.728c-5.911,10.649-13.975,24.491-21.597,35.324 C1604.318,1199.823,1583.741,1199.977,1583.741,1199.977z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180325892639037476060000007658787012855111844_",
    gradientUnits: "userSpaceOnUse",
    x1: 1573.2479,
    y1: 1165.8761,
    x2: 1890.2313,
    y2: 788.1945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180325892639037476060000007658787012855111844_)"
    },
    d: "M1610.662,1093.161l-30.685,26.013 l-9.634,25.898l27.358,30.352c0,0,9.199-51.388,16.036-62.511C1620.575,1101.792,1617.028,1096.414,1610.662,1093.161z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174595278801335769450000011799119650893897146_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.5197,
    y1: 1809.762,
    x2: 1492.7362,
    y2: 1056.8351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174595278801335769450000011799119650893897146_)"
    },
    d: "M767.083,1669.555l-67.367-170.063 c0,0-164.05,111.466-191.029,252.792c30.998,2.282,87.402,10.346,142.612,38.222 C663.432,1723.773,767.083,1669.555,767.083,1669.555z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078754052909275125650000007532527444344147331_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.9476,
    y1: 1862.011,
    x2: 934.82,
    y2: 1862.011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078754052909275125650000007532527444344147331_)"
    },
    d: "M910.444,1829.58 c0,0-184.188,104.095-246.334,15.21c-12.904-18.456-15.988-36.798-12.81-54.285c-55.21-27.877-111.615-35.94-142.612-38.222 c-8.134,42.604-3.833,87.918,21.201,133.716c108.862,199.139,404.932-11.006,404.932-11.006L910.444,1829.58z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M888.314,1961.27l100.523-351.047c1.142-3.986,4.542-6.892,8.659-7.372 c18.212-2.125,70.987-8.092,131.92-13.245c73.396-6.208,158.63-11.239,209.564-6.96c7.241,0.608,11.617,8.267,8.396,14.781 c-28.964,58.597-148.102,296.959-207.764,375.042c-1.977,2.586-5.035,4.099-8.289,4.068l-233.23-2.17 C891.307,1974.306,886.445,1967.795,888.314,1961.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083804310355696103400000001678459877561589378_",
    gradientUnits: "userSpaceOnUse",
    x1: 1410.5984,
    y1: 1222.7128,
    x2: 1279.0846,
    y2: 1414.9255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083804310355696103400000001678459877561589378_)"
    },
    d: "M1139.842,1559.172l72.881-12.143 c3.881-0.647,7.061,3.062,5.828,6.798l-7.215,21.862c-0.628,1.903-2.289,3.279-4.275,3.544l-70.133,9.369 c-3.629,0.486-6.619-2.811-5.785-6.376l4.466-19.087C1136.09,1561.083,1137.76,1559.518,1139.842,1559.172z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144329921918663673150000016452564267785643138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1422.0939,
    y1: 1230.5785,
    x2: 1290.5798,
    y2: 1422.7917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144329921918663673150000016452564267785643138_)"
    },
    d: "M1085.271,1620.871l6.003-31.273 c0.603-3.137,3.193-5.507,6.369-5.83l147.203-14.937c4.955-0.503,8.922,4.037,7.759,8.879l-9.359,38.971 c-0.75,3.118-3.462,5.37-6.666,5.532l-143.847,7.242C1088.052,1629.688,1084.387,1625.475,1085.271,1620.871z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155868861505468688140000008117181509732572291_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.904,
    y1: 1816.9386,
    x2: 1036.8265,
    y2: 1816.9386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155868861505468688140000008117181509732572291_)"
    },
    d: "M912.601,1876.457 c0,0-14.004-57.58-8.354-78.008c5.648-20.428,16.592-46.693,53.071-40.857c36.479,5.838,79.509,21.204,79.509,21.204 s-2.173,26.608-29.898,18.024l17.193,13.302c0,0-2.458,21.305-25.876,9.923l15.991,17.643c0,0-10.057,17.497-27.286,6.274 C969.719,1832.74,961.461,1883.39,912.601,1876.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147918379189593246770000011259567615656117667_",
    gradientUnits: "userSpaceOnUse",
    x1: 842.1742,
    y1: 1570.657,
    x2: 959.0759,
    y2: 1343.5974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147918379189593246770000011259567615656117667_)"
    },
    d: "M891.239,1310.79l-55.884,161.61 c-0.925,2.678,0.175,5.643,2.655,7.014c15.233,8.421,70.116,32.767,136.254-9.167c6.89-4.368,11.58-11.492,12.626-19.583 l18.098-139.874H891.239z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018208613110282899820000010962036123964177044_",
    gradientUnits: "userSpaceOnUse",
    x1: -3600.0979,
    y1: 1706.2491,
    x2: -3503.4294,
    y2: 2034.4717,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018208613110282899820000010962036123964177044_)"
    },
    d: "M1012.834,1161.132 c0,0,61.367,115.514,53.5,162.177c-7.866,46.663-83.919,43.313-150.332,5.415l-46.407-124.731L1012.834,1161.132z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093152137514631611950000008891739625235521953_",
    gradientUnits: "userSpaceOnUse",
    x1: -4498.6665,
    y1: -1517.804,
    x2: -4445.54,
    y2: -1214.7854,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093152137514631611950000008891739625235521953_)"
    },
    d: "M918.937,1267.468 c2.698-1.196,3.695-4.497,2.078-6.968c-4.916-7.511-14.133-22.834-17.072-36.249c0,0-11.032-7.065,28.078-16.426 c39.11-9.361,97.432-23.891,109.691-57.181c11.953-32.457-19.452-114.079-69.553-49.045c-1.906,2.475-5.64,2.53-7.544,0.053 c-8.214-10.689-29.807-32.879-59.786-19.426c-28.055,12.588-31.215,33.145-30.83,43.507c0.113,3.049-2.611,5.418-5.607,4.847 c-14.185-2.704-48.223-5.029-64.111,29.89c-13.086,28.761-4.581,45.042,3.166,53.004c2.509,2.579,1.409,6.828-2.031,7.881 c-9.323,2.853-21.361,10.758-20.156,32.598c1.667,30.193,35.425,27.533,45.037,26.157c1.574-0.226,3.16,0.314,4.226,1.495 c8.242,9.12,45.373,47.844,85.558,52.512c3.48,0.402,6.176-3.033,5.037-6.346l-17.391-50.553 c-0.808-2.349,0.316-4.924,2.586-5.929L918.937,1267.468z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183961502747555148610000004568874247673516958_",
    gradientUnits: "userSpaceOnUse",
    x1: -3659.6536,
    y1: 1723.7778,
    x2: -3562.9849,
    y2: 2052.0012,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 5126.3354 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183961502747555148610000004568874247673516958_)"
    },
    d: "M925.928,1274.644 c0,0-43.693-29.977-46.886-4.732c-3.192,25.244,39.346,36.567,60.417,27.154L925.928,1274.644z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076598299402268571180000002297208730831381123_",
    gradientUnits: "userSpaceOnUse",
    x1: 2541.5996,
    y1: 3339.6626,
    x2: 2521.3667,
    y2: 2924.8882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#4244E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076598299402268571180000002297208730831381123_)"
    },
    d: "M2175.196,2939.181l7.415,230.615 c1.293,40.213,34.294,72.214,74.716,72.453l552.249,3.255c27.016,0.159,50.032-19.471,53.977-46.073 c8.635-58.239,19.638-162.444,7.248-260.25H2175.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2794.371,3232.379c-0.003,0-0.007,0-0.01,0l-10.116-0.061c-0.932-0.005-1.683-0.766-1.676-1.696 c0.007-0.929,0.76-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.061c0.932,0.005,1.683,0.766,1.676,1.696 C2796.051,3231.631,2795.296,3232.379,2794.371,3232.379z M2760.653,3232.179c-0.003,0-0.007,0-0.01,0l-10.116-0.059 c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.059 c0.932,0.005,1.683,0.764,1.676,1.696C2762.332,3231.43,2761.578,3232.179,2760.653,3232.179z M2726.931,3231.98 c-0.003,0-0.007,0-0.01,0l-10.117-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.934,0.748-1.661,1.696-1.676l10.116,0.059 c0.932,0.005,1.683,0.764,1.676,1.696C2728.611,3231.231,2727.856,3231.98,2726.931,3231.98z M2693.21,3231.781 c-0.003,0-0.007,0-0.01,0l-10.116-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.928,0.761-1.676,1.686-1.676 c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696 C2694.889,3231.032,2694.135,3231.781,2693.21,3231.781z M2659.488,3231.583c-0.003,0-0.007,0-0.01,0l-10.116-0.061 c-0.932-0.005-1.683-0.766-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.061 c0.932,0.005,1.683,0.766,1.676,1.696C2661.167,3230.836,2660.413,3231.583,2659.488,3231.583z M2625.766,3231.384 c-0.003,0-0.007,0-0.01,0l-10.117-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676 c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696 C2627.446,3230.637,2626.692,3231.384,2625.766,3231.384z M2592.045,3231.185c-0.003,0-0.007,0-0.01,0l-10.113-0.059 c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.113,0.059 c0.932,0.005,1.683,0.764,1.676,1.696C2593.724,3230.436,2592.97,3231.185,2592.045,3231.185z M2558.326,3230.986 c-0.003,0-0.007,0-0.01,0l-10.116-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676 c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696 C2560.006,3230.237,2559.252,3230.986,2558.326,3230.986z M2524.605,3230.788c-0.003,0-0.007,0-0.01,0l-10.116-0.061 c-0.932-0.005-1.683-0.766-1.676-1.696c0.007-0.929,0.76-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.061 c0.932,0.005,1.683,0.766,1.676,1.696C2526.284,3230.041,2525.53,3230.788,2524.605,3230.788z M2490.883,3230.589 c-0.003,0-0.007,0-0.01,0l-10.116-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.932,0.912-1.663,1.696-1.676l10.117,0.059 c0.932,0.005,1.683,0.764,1.676,1.696C2492.563,3229.841,2491.809,3230.589,2490.883,3230.589z M2457.162,3230.39 c-0.003,0-0.006,0-0.01,0l-10.116-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676 c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696C2458.841,3229.642,2458.087,3230.39,2457.162,3230.39 z M2423.44,3230.19c-0.003,0-0.007,0-0.01,0l-10.117-0.059c-0.932-0.005-1.683-0.764-1.676-1.696 c0.007-0.929,0.76-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696 C2425.12,3229.441,2424.365,3230.19,2423.44,3230.19z M2389.722,3229.993c-0.003,0-0.007,0-0.01,0l-10.116-0.061 c-0.932-0.005-1.683-0.766-1.676-1.696c0.007-0.928,0.761-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.061 c0.932,0.005,1.683,0.766,1.676,1.696C2391.401,3229.245,2390.647,3229.993,2389.722,3229.993z M2356,3229.794 c-0.003,0-0.007,0-0.01,0l-10.117-0.059c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.927,0.761-1.676,1.686-1.676 c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696C2357.68,3229.046,2356.926,3229.794,2356,3229.794z  M2322.279,3229.594c-0.003,0-0.007,0-0.01,0l-10.116-0.059c-0.932-0.005-1.683-0.764-1.676-1.696 c0.007-0.927,0.761-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.059c0.932,0.005,1.683,0.764,1.676,1.696 C2323.958,3228.847,2323.204,3229.594,2322.279,3229.594z M2288.557,3229.395c-0.003,0-0.007,0-0.01,0l-10.116-0.059 c-0.932-0.005-1.683-0.764-1.676-1.696c0.007-0.929,0.761-1.676,1.686-1.676c0.003,0,0.007,0,0.01,0l10.116,0.059 c0.932,0.005,1.683,0.764,1.676,1.696C2290.237,3228.648,2289.482,3229.395,2288.557,3229.395z M2817.337,3227.877 c-0.642,0-1.258-0.37-1.538-0.996c-0.382-0.851,0-1.847,0.85-2.229c2.977-1.332,5.829-2.962,8.483-4.843 c0.758-0.538,1.808-0.364,2.351,0.4c0.537,0.759,0.359,1.811-0.402,2.35c-2.832,2.009-5.878,3.749-9.056,5.172 C2817.802,3227.829,2817.568,3227.877,2817.337,3227.877z M2254.967,3227.554c-0.122,0-0.244-0.013-0.369-0.041 c-3.362-0.751-6.695-1.75-9.909-2.966c-0.873-0.329-1.311-1.302-0.981-2.173c0.333-0.871,1.311-1.314,2.174-0.981 c3.066,1.161,6.247,2.113,9.455,2.831c0.909,0.202,1.479,1.105,1.278,2.014 C2256.436,3227.021,2255.741,3227.554,2254.967,3227.554z M2224.983,3212.845c-0.379,0-0.761-0.127-1.073-0.387 c-2.651-2.193-5.167-4.595-7.485-7.139c-0.626-0.688-0.576-1.755,0.112-2.381c0.688-0.627,1.758-0.576,2.384,0.112 c2.21,2.427,4.61,4.719,7.136,6.81c0.718,0.594,0.82,1.656,0.224,2.374C2225.948,3212.638,2225.467,3212.845,2224.983,3212.845z  M2841.631,3205.37c-0.273,0-0.547-0.066-0.803-0.203c-0.817-0.443-1.123-1.467-0.678-2.285c1.541-2.853,2.813-5.885,3.774-9.008 c0.27-0.891,1.202-1.395,2.108-1.116c0.889,0.275,1.39,1.218,1.113,2.107c-1.024,3.336-2.381,6.573-4.031,9.621 C2842.81,3205.051,2842.23,3205.37,2841.631,3205.37z M2204.931,3186.132c-0.652,0-1.274-0.382-1.548-1.019 c-1.367-3.171-2.513-6.461-3.405-9.776c-0.244-0.899,0.29-1.824,1.189-2.068c0.889-0.237,1.824,0.293,2.065,1.189 c0.853,3.161,1.946,6.296,3.247,9.321c0.369,0.856-0.026,1.847-0.883,2.216 C2205.379,3186.087,2205.156,3186.132,2204.931,3186.132z M2849.455,3172.8c-0.076,0-0.151-0.005-0.227-0.015 c-0.922-0.124-1.571-0.973-1.446-1.895c0.431-3.237,0.866-6.58,1.297-10.019c0.115-0.927,0.988-1.579,1.884-1.464 c0.922,0.115,1.577,0.958,1.462,1.882c-0.431,3.449-0.866,6.802-1.304,10.049C2851.01,3172.184,2850.285,3172.8,2849.455,3172.8z  M2198.964,3153.202c-0.909,0-1.656-0.719-1.686-1.632l-0.323-10.11c-0.03-0.932,0.701-1.709,1.633-1.739 c0.896-0.128,1.706,0.701,1.739,1.63l0.323,10.11c0.03,0.932-0.701,1.709-1.633,1.739 C2199,3153.202,2198.981,3153.202,2198.964,3153.202z M2853.46,3139.312c-0.059,0-0.119-0.003-0.178-0.01 c-0.929-0.097-1.6-0.925-1.502-1.852c0.346-3.292,0.685-6.644,1.011-10.052c0.089-0.93,0.932-1.628,1.841-1.517 c0.929,0.089,1.607,0.912,1.518,1.839c-0.333,3.418-0.672,6.781-1.018,10.082 C2855.044,3138.668,2854.309,3139.312,2853.46,3139.312z M2197.881,3119.499c-0.909,0-1.656-0.719-1.686-1.632l-0.323-10.112 c-0.03-0.932,0.701-1.709,1.634-1.739c0.869-0.107,1.709,0.701,1.739,1.63l0.323,10.112c0.03,0.932-0.701,1.709-1.633,1.739 C2197.917,3119.499,2197.897,3119.499,2197.881,3119.499z M2856.493,3105.722c-0.043,0-0.086-0.001-0.129-0.005 c-0.928-0.069-1.627-0.879-1.558-1.808c0.25-3.321,0.488-6.682,0.715-10.079c0.059-0.927,0.771-1.604,1.795-1.571 c0.928,0.063,1.633,0.866,1.571,1.795c-0.227,3.407-0.464,6.777-0.715,10.108 C2858.103,3105.048,2857.365,3105.722,2856.493,3105.722z M2196.798,3085.795c-0.906,0-1.656-0.719-1.686-1.632l-0.326-10.111 c-0.03-0.93,0.701-1.709,1.633-1.739c0.948-0.127,1.709,0.701,1.739,1.63l0.326,10.112c0.03,0.93-0.702,1.709-1.63,1.739 C2196.834,3085.795,2196.814,3085.795,2196.798,3085.795z M2858.495,3072.055c-0.023,0-0.05,0-0.073-0.002 c-0.932-0.04-1.653-0.827-1.614-1.757c0.145-3.341,0.273-6.707,0.389-10.097c0.033-0.93,0.82-1.661,1.742-1.627 c0.932,0.031,1.66,0.812,1.63,1.742c-0.115,3.4-0.244,6.775-0.388,10.126C2860.141,3071.347,2859.394,3072.055,2858.495,3072.055 z M2195.714,3052.09c-0.906,0-1.656-0.719-1.686-1.632l-0.326-10.112c-0.03-0.93,0.701-1.709,1.633-1.739 c0.926-0.077,1.709,0.7,1.739,1.63l0.326,10.112c0.03,0.93-0.701,1.709-1.63,1.739 C2195.75,3052.09,2195.73,3052.09,2195.714,3052.09z M2859.381,3038.344c-0.003,0-0.01,0-0.013,0 c-0.932-0.008-1.679-0.769-1.673-1.699c0.02-2.448,0.03-4.904,0.03-7.367l-0.003-2.728c-0.003-0.932,0.748-1.689,1.679-1.693 c0.003,0,0.003,0,0.007,0c0.929,0,1.683,0.751,1.686,1.68l0.003,2.741c0,2.473-0.01,4.938-0.03,7.393 C2861.06,3037.599,2860.306,3038.344,2859.381,3038.344z M2194.631,3018.386c-0.906,0-1.656-0.719-1.686-1.632l-0.326-10.112 c-0.03-0.93,0.701-1.709,1.634-1.739c0.902-0.122,1.706,0.701,1.739,1.63l0.326,10.111c0.03,0.93-0.701,1.709-1.63,1.739 C2194.667,3018.386,2194.647,3018.386,2194.631,3018.386z M2859.002,3004.629c-0.909,0-1.656-0.721-1.686-1.633 c-0.105-3.356-0.234-6.719-0.382-10.085c-0.043-0.93,0.678-1.719,1.607-1.76c0.978-0.069,1.716,0.682,1.758,1.609 c0.155,3.382,0.283,6.759,0.389,10.131c0.03,0.93-0.701,1.709-1.633,1.737 C2859.038,3004.629,2859.018,3004.629,2859.002,3004.629z M2193.547,2984.681c-0.906,0-1.656-0.719-1.686-1.632l-0.326-10.112 c-0.03-0.93,0.701-1.709,1.633-1.739c0.879-0.073,1.706,0.701,1.739,1.63l0.326,10.111c0.03,0.93-0.701,1.709-1.633,1.739 C2193.583,2984.681,2193.564,2984.681,2193.547,2984.681z M2857.177,2970.961c-0.869,0-1.61-0.672-1.676-1.556 c-0.26-3.354-0.547-6.705-0.859-10.054c-0.086-0.927,0.596-1.749,1.525-1.836c0.909-0.076,1.749,0.594,1.834,1.523 c0.313,3.365,0.599,6.736,0.86,10.107c0.073,0.928-0.623,1.739-1.548,1.811 C2857.266,2970.959,2857.224,2970.961,2857.177,2970.961z M2192.464,2950.978c-0.906,0-1.656-0.719-1.686-1.632l-0.326-10.112 c-0.03-0.93,0.701-1.709,1.633-1.739c0.856-0.117,1.709,0.701,1.739,1.63l0.326,10.112c0.03,0.93-0.701,1.709-1.634,1.739 C2192.5,2950.978,2192.48,2950.978,2192.464,2950.978z M2850.657,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2852.343,2940.112,2851.589,2940.866,2850.657,2940.866z M2816.936,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2818.622,2940.112,2817.867,2940.866,2816.936,2940.866z M2783.214,2940.866h-10.117c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.117c0.932,0,1.686,0.754,1.686,1.686C2784.9,2940.112,2784.146,2940.866,2783.214,2940.866z  M2749.492,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.116 c0.932,0,1.686,0.754,1.686,1.686C2751.178,2940.112,2750.424,2940.866,2749.492,2940.866z M2715.771,2940.866h-10.116 c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2717.457,2940.112,2716.703,2940.866,2715.771,2940.866z M2682.049,2940.866h-10.117c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.117c0.932,0,1.686,0.754,1.686,1.686 C2683.735,2940.112,2682.981,2940.866,2682.049,2940.866z M2648.328,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686C2650.014,2940.112,2649.26,2940.866,2648.328,2940.866 z M2614.606,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.116 c0.932,0,1.686,0.754,1.686,1.686C2616.292,2940.112,2615.538,2940.866,2614.606,2940.866z M2580.885,2940.866h-10.117 c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.117c0.932,0,1.686,0.754,1.686,1.686 C2582.571,2940.112,2581.816,2940.866,2580.885,2940.866z M2547.163,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2548.849,2940.112,2548.095,2940.866,2547.163,2940.866z M2513.441,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2515.127,2940.112,2514.373,2940.866,2513.441,2940.866z M2479.719,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2481.406,2940.112,2480.652,2940.866,2479.719,2940.866z M2445.998,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686C2447.684,2940.112,2446.93,2940.866,2445.998,2940.866 z M2412.277,2940.866h-10.117c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.117 c0.932,0,1.686,0.754,1.686,1.686C2413.962,2940.112,2413.208,2940.866,2412.277,2940.866z M2378.555,2940.866h-10.116 c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2380.241,2940.112,2379.487,2940.866,2378.555,2940.866z M2344.833,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2346.519,2940.112,2345.765,2940.866,2344.833,2940.866z M2311.112,2940.866h-10.117c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.117c0.932,0,1.686,0.754,1.686,1.686 C2312.798,2940.112,2312.044,2940.866,2311.112,2940.866z M2277.39,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686 c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686C2279.076,2940.112,2278.322,2940.866,2277.39,2940.866 z M2243.668,2940.866h-10.116c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.116 c0.932,0,1.686,0.754,1.686,1.686C2245.354,2940.112,2244.601,2940.866,2243.668,2940.866z M2209.947,2940.866h-10.117 c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.117c0.932,0,1.686,0.754,1.686,1.686 C2211.633,2940.112,2210.879,2940.866,2209.947,2940.866z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059278498578679219250000010236805856469737872_",
    gradientUnits: "userSpaceOnUse",
    x1: 2386.6484,
    y1: 2817.8833,
    x2: 2382.592,
    y2: 2719.5178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059278498578679219250000010236805856469737872_)"
    },
    d: "M2337.042,2771.765l1.661-17.786 c1.875-4.246,5.769-7.252,10.371-7.984c17.205-2.74,59.874-7.553,80.42,7.801l3.069,20.668L2337.042,2771.765z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000218284814543021870000004656039670227587224_",
    gradientUnits: "userSpaceOnUse",
    x1: 2381.5129,
    y1: 2670.1997,
    x2: 2401.7944,
    y2: 2952.1143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000218284814543021870000004656039670227587224_)"
    },
    d: "M2390.786,2754.652 c-3.961,0.966-7.929,0.963-11.906-0.014c-4.81-1.182-8.203-5.486-8.203-10.417l0-55.692h28.342l0,55.651 C2399.021,2749.133,2395.62,2753.473,2390.786,2754.652z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137848117719001932130000007969024080266019227_",
    gradientUnits: "userSpaceOnUse",
    x1: 2660.6963,
    y1: 2806.5823,
    x2: 2656.6399,
    y2: 2708.2168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137848117719001932130000007969024080266019227_)"
    },
    d: "M2611.555,2771.765l1.661-17.786 c1.875-4.246,5.769-7.252,10.371-7.984c17.205-2.74,59.875-7.553,80.419,7.801l3.069,20.668L2611.555,2771.765z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007422086596906190760000004734738545735712938_",
    gradientUnits: "userSpaceOnUse",
    x1: 2654.8232,
    y1: 2650.5371,
    x2: 2675.1047,
    y2: 2932.4514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007422086596906190760000004734738545735712938_)"
    },
    d: "M2665.3,2754.652 c-3.961,0.966-7.93,0.963-11.906-0.014c-4.81-1.182-8.203-5.486-8.203-10.417l0-61.56h28.342l0,61.519 C2673.534,2749.133,2670.134,2753.473,2665.3,2754.652z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023268225898725382510000000988718244712980662_",
    gradientUnits: "userSpaceOnUse",
    x1: 2747.6067,
    y1: 2558.4128,
    x2: 2410.3911,
    y2: 2721.9624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023268225898725382510000000988718244712980662_)"
    },
    d: "M2367.799,2702.18l304.8-10.09 c6.95-0.23,12.846-5.243,14.039-12.061c1.67-9.542,3.143-23.827,0.947-38.635c-2.496-16.839-16.981-29.348-34.078-29.756 c-56.861-1.353-201.614-1.312-281.394,30.247c-8.438,3.338-14.696,10.549-16.833,19.333c-2.038,8.378-3.392,19.565-0.73,30.951 C2355.965,2698.218,2361.563,2702.386,2367.799,2702.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2362.521,2688.369c-1.709,0-3.175-1.296-3.353-3.033c-0.049-0.497-1.195-12.318,1.887-23.704 c2.447-9.058,9.609-16.342,18.695-19.008c17.075-5.01,49.716-13.528,76.45-14.277c1.792-0.124,3.415,1.413,3.468,3.276 c0.05,1.861-1.416,3.412-3.277,3.465c-25.976,0.729-57.979,9.089-74.744,14.007c-6.846,2.01-12.244,7.489-14.082,14.297 c-2.76,10.199-1.699,21.157-1.686,21.266c0.188,1.852-1.162,3.507-3.017,3.695 C2362.748,2688.365,2362.633,2688.369,2362.521,2688.369z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031206767611673277210000016930556208899957394_",
    gradientUnits: "userSpaceOnUse",
    x1: 2518.0261,
    y1: 2979.4849,
    x2: 2570.2942,
    y2: 2448.3689
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031206767611673277210000016930556208899957394_)"
    },
    d: "M2195.625,2764.836 c98.471-1.259,524.452-5.735,648.19,9.194c10.654,1.286,19.347,9.08,21.655,19.512c7.312,33.054,22.021,109.842,20.278,185.957 c-0.237,10.358-7.832,19.098-18.059,21.034l-282.453,53.435h-100.332l-300.958-59.823c-10.608-2.109-18.428-11.094-18.977-21.847 c-1.956-38.294-5.014-128.145,5.342-185.98C2172.512,2774.029,2183.084,2764.997,2195.625,2764.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2559.91,3031.317h-10.116c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686 h10.116c0.932,0,1.686,0.754,1.686,1.686C2561.597,3030.563,2560.843,3031.317,2559.91,3031.317z M2526.189,3031.317h-10.116 c-0.932,0-1.686-0.754-1.686-1.686c0-0.932,0.754-1.686,1.686-1.686h10.116c0.932,0,1.686,0.754,1.686,1.686 C2527.875,3030.563,2527.121,3031.317,2526.189,3031.317z M2492.467,3031.317h-5.167l-10.251-2.005 c-0.912-0.181-1.505-1.069-1.324-1.982c0.178-0.917,1.093-1.505,1.982-1.324l9.922,1.973l4.838-0.033 c0.932,0,1.686,0.754,1.686,1.686C2494.153,3030.563,2493.399,3031.317,2492.467,3031.317z M2583.502,3031.212 c-0.794,0-1.502-0.563-1.653-1.373c-0.175-0.914,0.428-1.796,1.344-1.969l9.942-1.88c0.896-0.173,1.798,0.427,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.942,1.88C2583.713,3031.202,2583.608,3031.212,2583.502,3031.212z M2616.638,3024.943 c-0.794,0-1.502-0.563-1.653-1.373c-0.174-0.914,0.428-1.796,1.344-1.969l9.939-1.88c0.886-0.169,1.795,0.425,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.938,1.88C2616.849,3024.933,2616.743,3024.943,2616.638,3024.943z M2454.228,3024.742 c-0.112,0-0.221-0.01-0.333-0.033l-9.922-1.972c-0.912-0.181-1.505-1.069-1.324-1.982c0.181-0.917,1.09-1.513,1.982-1.324 l9.922,1.973c0.912,0.181,1.505,1.069,1.324,1.982C2455.719,3024.188,2455.015,3024.742,2454.228,3024.742z M2649.77,3018.675 c-0.794,0-1.502-0.563-1.653-1.373c-0.174-0.914,0.428-1.796,1.344-1.969l9.942-1.88c0.902-0.167,1.798,0.427,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.942,1.88C2649.981,3018.665,2649.875,3018.675,2649.77,3018.675z M2421.155,3018.167 c-0.112,0-0.221-0.01-0.333-0.033l-9.922-1.971c-0.912-0.181-1.505-1.069-1.324-1.983c0.181-0.916,1.087-1.511,1.982-1.324 l9.922,1.971c0.912,0.181,1.505,1.069,1.324,1.981C2422.646,3017.613,2421.942,3018.167,2421.155,3018.167z M2682.906,3012.406 c-0.794,0-1.502-0.563-1.653-1.373c-0.175-0.914,0.428-1.796,1.344-1.969l9.939-1.88c0.893-0.176,1.798,0.427,1.969,1.344 c0.174,0.914-0.428,1.796-1.344,1.969l-9.939,1.881C2683.116,3012.396,2683.011,3012.406,2682.906,3012.406z M2388.079,3011.594 c-0.112,0-0.221-0.01-0.333-0.033l-9.922-1.972c-0.912-0.181-1.505-1.069-1.324-1.983c0.181-0.916,1.083-1.508,1.982-1.324 l9.922,1.972c0.912,0.181,1.505,1.069,1.324,1.983C2389.57,3011.04,2388.865,3011.594,2388.079,3011.594z M2716.038,3006.138 c-0.794,0-1.502-0.563-1.653-1.373c-0.175-0.914,0.428-1.796,1.344-1.969l9.942-1.88c0.909-0.173,1.795,0.427,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.942,1.88C2716.248,3006.128,2716.143,3006.138,2716.038,3006.138z M2355.006,3005.02 c-0.112,0-0.22-0.01-0.333-0.033l-9.922-1.973c-0.912-0.181-1.505-1.069-1.324-1.982c0.181-0.917,1.077-1.503,1.983-1.324 l9.922,1.972c0.912,0.181,1.505,1.069,1.324,1.983C2356.498,3004.465,2355.793,3005.02,2355.006,3005.02z M2749.173,2999.869 c-0.793,0-1.501-0.563-1.653-1.373c-0.175-0.914,0.428-1.796,1.344-1.969l9.939-1.88c0.902-0.17,1.798,0.425,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.939,1.88C2749.384,2999.859,2749.278,2999.869,2749.173,2999.869z M2321.93,2998.445 c-0.112,0-0.221-0.01-0.333-0.033l-9.922-1.973c-0.912-0.181-1.505-1.069-1.324-1.982c0.181-0.916,1.073-1.513,1.982-1.324 l9.922,1.972c0.912,0.181,1.505,1.069,1.324,1.983C2323.421,2997.89,2322.717,2998.445,2321.93,2998.445z M2782.305,2993.601 c-0.794,0-1.502-0.563-1.653-1.373c-0.175-0.914,0.428-1.796,1.344-1.969l9.942-1.88c0.889-0.166,1.798,0.425,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.942,1.88C2782.516,2993.591,2782.41,2993.601,2782.305,2993.601z M2288.857,2991.87 c-0.112,0-0.221-0.01-0.333-0.033l-9.922-1.973c-0.912-0.181-1.505-1.069-1.324-1.982c0.178-0.916,1.094-1.508,1.982-1.324 l9.922,1.972c0.912,0.181,1.505,1.069,1.324,1.982C2290.348,2991.315,2289.644,2991.87,2288.857,2991.87z M2815.44,2987.333 c-0.794,0-1.502-0.563-1.653-1.374c-0.175-0.914,0.428-1.796,1.344-1.969l9.939-1.88c0.909-0.163,1.798,0.426,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.939,1.88C2815.651,2987.323,2815.546,2987.333,2815.44,2987.333z M2255.781,2985.296 c-0.112,0-0.22-0.01-0.333-0.033l-9.922-1.973c-0.912-0.181-1.505-1.069-1.324-1.982c0.178-0.916,1.094-1.505,1.983-1.324 l9.922,1.972c0.912,0.181,1.505,1.069,1.324,1.982C2257.272,2984.741,2256.568,2985.296,2255.781,2985.296z M2848.573,2981.064 c-0.794,0-1.502-0.563-1.653-1.373c-0.175-0.914,0.428-1.796,1.344-1.969l9.942-1.88c0.896-0.173,1.798,0.427,1.969,1.344 c0.175,0.914-0.428,1.796-1.344,1.969l-9.942,1.88C2848.783,2981.054,2848.678,2981.064,2848.573,2981.064z M2222.708,2978.722 c-0.112,0-0.221-0.01-0.333-0.033l-9.922-1.973c-0.912-0.181-1.505-1.069-1.324-1.982c0.181-0.917,1.087-1.503,1.982-1.324 l9.922,1.973c0.912,0.181,1.505,1.069,1.324,1.982C2224.2,2978.167,2223.495,2978.722,2222.708,2978.722z M2189.632,2972.148 c-0.112,0-0.224-0.01-0.336-0.033l-1.669-0.336l-0.066-1.309c-0.148-2.918-0.303-6.176-0.461-9.726 c-0.039-0.93,0.682-1.717,1.614-1.759c0.853-0.11,1.716,0.683,1.759,1.61c0.135,3.155,0.273,6.078,0.408,8.735 c0.346,0.382,0.51,0.919,0.402,1.464C2191.12,2971.594,2190.415,2972.148,2189.632,2972.148z M2861.445,2958.014 c-0.916,0-1.666-0.733-1.686-1.653c-0.066-3.369-0.158-6.731-0.277-10.083c-0.033-0.93,0.695-1.711,1.627-1.744 c0.938-0.115,1.712,0.693,1.745,1.625c0.118,3.369,0.211,6.751,0.277,10.136c0.016,0.93-0.721,1.701-1.653,1.719 C2861.469,2958.014,2861.455,2958.014,2861.445,2958.014z M2187.926,2938.762c-0.909,0-1.66-0.723-1.686-1.637 c-0.095-3.273-0.181-6.654-0.257-10.128c-0.02-0.93,0.718-1.701,1.65-1.722c0.883,0.026,1.702,0.718,1.722,1.65 c0.076,3.464,0.161,6.838,0.257,10.102c0.026,0.93-0.705,1.708-1.637,1.736 C2187.959,2938.762,2187.942,2938.762,2187.926,2938.762z M2859.901,2924.333c-0.876,0-1.617-0.678-1.679-1.568 c-0.24-3.379-0.5-6.736-0.784-10.065c-0.079-0.929,0.609-1.745,1.538-1.823c0.853-0.107,1.739,0.606,1.821,1.536 c0.283,3.346,0.55,6.719,0.79,10.115c0.066,0.929-0.635,1.734-1.564,1.8C2859.983,2924.332,2859.944,2924.333,2859.901,2924.333z  M2187.336,2905.041c-0.925,0-1.679-0.748-1.686-1.676c-0.013-2.259-0.02-4.54-0.017-6.835l0.003-3.3 c0.003-0.93,0.757-1.681,1.686-1.681c0.003,0,0.003,0,0.006,0c0.929,0.003,1.683,0.761,1.68,1.691l-0.003,3.292 c-0.003,2.29,0.003,4.561,0.017,6.813c0.007,0.932-0.744,1.691-1.676,1.696 C2187.343,2905.041,2187.34,2905.041,2187.336,2905.041z M2856.766,2890.747c-0.843,0-1.574-0.634-1.673-1.495 c-0.385-3.389-0.791-6.733-1.208-10.026c-0.115-0.924,0.537-1.768,1.462-1.885c0.876-0.099,1.765,0.537,1.884,1.46 c0.418,3.306,0.823,6.664,1.215,10.069c0.105,0.925-0.56,1.76-1.485,1.865 C2856.894,2890.743,2856.832,2890.747,2856.766,2890.747z M2187.633,2871.316c-0.013,0-0.026,0-0.04,0 c-0.932-0.023-1.67-0.797-1.647-1.727c0.083-3.377,0.181-6.759,0.303-10.136c0.036-0.929,0.879-1.642,1.746-1.624 c0.932,0.033,1.66,0.815,1.627,1.745c-0.122,3.364-0.221,6.733-0.303,10.097 C2189.296,2870.588,2188.545,2871.316,2187.633,2871.316z M2852.274,2857.313c-0.817,0-1.535-0.596-1.663-1.429 c-0.527-3.418-1.057-6.746-1.591-9.978c-0.152-0.917,0.471-1.785,1.39-1.937c0.912-0.156,1.785,0.469,1.936,1.388 c0.533,3.244,1.07,6.584,1.597,10.013c0.142,0.92-0.491,1.781-1.409,1.923C2852.448,2857.307,2852.36,2857.313,2852.274,2857.313 z M2189.118,2837.619c-0.04,0-0.079-0.001-0.115-0.003c-0.929-0.063-1.633-0.866-1.571-1.795c0.227-3.408,0.481-6.786,0.76-10.12 c0.076-0.929,0.942-1.63,1.821-1.538c0.929,0.077,1.617,0.892,1.538,1.821c-0.28,3.314-0.527,6.672-0.754,10.061 C2190.738,2836.935,2189.997,2837.619,2189.118,2837.619z M2846.544,2824.063c-0.79,0-1.498-0.561-1.653-1.37 c-0.675-3.524-1.327-6.835-1.953-9.912c-0.184-0.914,0.405-1.803,1.317-1.989c0.932-0.173,1.804,0.405,1.989,1.317 c0.626,3.091,1.281,6.415,1.959,9.952c0.175,0.914-0.425,1.798-1.34,1.973 C2846.758,2824.053,2846.649,2824.063,2846.544,2824.063z M2192.417,2804.057c-0.079,0-0.155-0.005-0.234-0.017 c-0.922-0.127-1.568-0.978-1.439-1.9c0.478-3.446,0.991-6.804,1.548-10.054c0.158-0.92,1.044-1.534,1.946-1.376 c0.919,0.156,1.534,1.028,1.38,1.946c-0.55,3.214-1.063,6.535-1.534,9.945 C2193.969,2803.446,2193.244,2804.057,2192.417,2804.057z M2832.354,2798.928c-0.059,0-0.115-0.003-0.175-0.008 c-3.161-0.324-6.51-0.639-10.044-0.947c-0.929-0.081-1.617-0.897-1.535-1.826c0.079-0.929,0.912-1.633,1.824-1.533 c3.553,0.308,6.922,0.626,10.097,0.95c0.925,0.095,1.6,0.924,1.505,1.849C2833.938,2798.281,2833.207,2798.928,2832.354,2798.928 z M2798.744,2796.219c-0.04,0-0.076-0.002-0.112-0.003c-3.257-0.211-6.619-0.417-10.087-0.617 c-0.928-0.052-1.637-0.851-1.584-1.78c0.056-0.93,0.81-1.62,1.782-1.586c3.474,0.201,6.843,0.407,10.106,0.617 c0.929,0.061,1.634,0.863,1.574,1.792C2800.365,2795.534,2799.624,2796.219,2798.744,2796.219z M2765.069,2794.378 c-0.026,0-0.053,0-0.079-0.002c-3.296-0.153-6.662-0.303-10.103-0.449c-0.929-0.04-1.653-0.827-1.614-1.757 c0.04-0.929,0.738-1.704,1.759-1.612c3.441,0.146,6.813,0.296,10.116,0.449c0.928,0.043,1.65,0.833,1.604,1.762 C2766.712,2793.674,2765.965,2794.378,2765.069,2794.378z M2731.37,2793.018c-0.02,0-0.04,0-0.059-0.002l-10.103-0.341 c-0.932-0.03-1.663-0.808-1.634-1.739c0.03-0.929,0.813-1.726,1.739-1.63l10.117,0.341c0.932,0.033,1.66,0.813,1.627,1.744 C2733.023,2792.302,2732.276,2793.018,2731.37,2793.018z M2697.665,2791.981c-0.013,0-0.03,0-0.046,0l-10.11-0.263 c-0.932-0.025-1.666-0.797-1.643-1.729c0.023-0.916,0.774-1.643,1.686-1.643c0.013,0,0.026,0,0.043,0l10.116,0.263 c0.932,0.026,1.667,0.802,1.64,1.732C2699.325,2791.257,2698.577,2791.981,2697.665,2791.981z M2663.954,2791.174 c-0.01,0-0.023,0-0.036,0l-10.113-0.203c-0.932-0.018-1.67-0.787-1.653-1.719c0.017-0.93,0.774-1.604,1.719-1.653l10.12,0.202 c0.929,0.02,1.669,0.79,1.65,1.721C2665.62,2790.441,2664.869,2791.174,2663.954,2791.174z M2215.371,2790.621 c-0.922,0-1.676-0.742-1.686-1.666c-0.01-0.932,0.734-1.696,1.666-1.706l10.123-0.114c0.883,0.028,1.696,0.736,1.706,1.668 c0.01,0.93-0.738,1.694-1.666,1.704l-10.123,0.114C2215.384,2790.621,2215.377,2790.621,2215.371,2790.621z M2630.232,2790.555 c-0.01,0-0.017,0-0.026,0l-10.116-0.156c-0.929-0.015-1.673-0.781-1.66-1.711c0.013-0.924,0.767-1.661,1.686-1.661 c0.007,0,0.016,0,0.026,0l10.117,0.156c0.932,0.015,1.673,0.782,1.66,1.712 C2631.905,2789.817,2631.151,2790.555,2630.232,2790.555z M2249.109,2790.259c-0.922,0-1.676-0.744-1.686-1.67 c-0.01-0.93,0.738-1.693,1.67-1.703l10.123-0.097c0.007,0,0.013,0,0.016,0c0.926,0,1.676,0.744,1.686,1.671 c0.01,0.93-0.741,1.693-1.67,1.701l-10.123,0.097C2249.119,2790.259,2249.115,2790.259,2249.109,2790.259z M2596.51,2790.081 c-0.007,0-0.013,0-0.02,0l-10.116-0.118c-0.929-0.01-1.676-0.774-1.666-1.704c0.01-0.925,0.764-1.668,1.686-1.668 c0.007,0,0.013,0,0.02,0l10.116,0.119c0.932,0.011,1.676,0.775,1.666,1.708C2598.187,2789.34,2597.432,2790.081,2596.51,2790.081 z M2282.847,2789.954c-0.925,0-1.679-0.746-1.686-1.671c-0.007-0.932,0.741-1.693,1.673-1.701l10.12-0.082 c0.003,0,0.01,0,0.013,0c0.925,0,1.679,0.746,1.686,1.673c0.007,0.932-0.741,1.692-1.673,1.699l-10.12,0.083 C2282.857,2789.954,2282.85,2789.954,2282.847,2789.954z M2562.789,2789.729c-0.003,0-0.01,0-0.017,0l-10.113-0.084 c-0.932-0.007-1.679-0.767-1.673-1.699c0.007-0.927,0.761-1.673,1.686-1.673c0.003,0,0.01,0,0.013,0l10.12,0.084 c0.929,0.008,1.676,0.771,1.67,1.701C2564.465,2788.983,2563.714,2789.729,2562.789,2789.729z M2316.578,2789.699 c-0.926,0-1.68-0.747-1.686-1.674c-0.007-0.93,0.744-1.691,1.673-1.698l10.123-0.066c0.003,0,0.007,0,0.01,0 c0.925,0,1.679,0.748,1.686,1.676c0.007,0.93-0.744,1.689-1.676,1.696l-10.116,0.066 C2316.585,2789.699,2316.582,2789.699,2316.578,2789.699z M2350.31,2789.498c-0.929,0-1.683-0.749-1.686-1.678 c-0.003-0.93,0.747-1.689,1.676-1.694l10.12-0.049c0,0,0.003,0,0.007,0c0.929,0,1.683,0.749,1.686,1.678 c0.003,0.932-0.748,1.689-1.679,1.694l-10.113,0.05C2350.316,2789.498,2350.313,2789.498,2350.31,2789.498z M2529.067,2789.481 c-0.003,0-0.007,0-0.01,0l-10.116-0.054c-0.932-0.005-1.683-0.762-1.68-1.694c0.003-0.929,0.758-1.678,1.686-1.678 c0.003,0,0.007,0,0.007,0l10.123,0.054c0.932,0.005,1.683,0.766,1.676,1.696 C2530.747,2788.732,2529.992,2789.481,2529.067,2789.481z M2384.044,2789.355c-0.929,0-1.683-0.751-1.686-1.681 c-0.003-0.93,0.748-1.688,1.679-1.691l10.12-0.033c0.962,0.003,1.686,0.746,1.693,1.679c0.003,0.932-0.748,1.689-1.679,1.693 l-10.12,0.033C2384.048,2789.355,2384.048,2789.355,2384.044,2789.355z M2495.345,2789.33c-0.003,0-0.003,0-0.007,0l-10.113-0.03 c-0.932-0.002-1.686-0.759-1.683-1.689c0.003-0.93,0.757-1.683,1.686-1.683h0.003l10.12,0.03 c0.932,0.003,1.683,0.761,1.679,1.693C2497.028,2788.579,2496.274,2789.33,2495.345,2789.33z M2417.776,2789.269 c-0.928,0-1.686-0.752-1.686-1.684c0-0.93,0.751-1.686,1.683-1.688l10.123-0.013l0,0c0.932,0,1.686,0.754,1.686,1.684 c0,0.932-0.754,1.686-1.683,1.688l-10.12,0.013C2417.776,2789.269,2417.776,2789.269,2417.776,2789.269z M2461.621,2789.258 L2461.621,2789.258l-10.116-0.008c-0.932,0-1.686-0.756-1.686-1.688c0-0.93,0.754-1.684,1.686-1.684l0,0l10.116,0.008 c0.932,0.001,1.686,0.756,1.686,1.688C2463.307,2788.503,2462.552,2789.258,2461.621,2789.258z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083805771476911351600000010173604944159685558_",
    gradientUnits: "userSpaceOnUse",
    x1: 2818.7896,
    y1: 2381.3975,
    x2: 2683.9033,
    y2: 2681.5193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083805771476911351600000010173604944159685558_)"
    },
    d: "M2575.789,3096.092h-87.899 c-11.519,0-21.219-8.57-22.586-19.954l-10.156-84.582c-1.617-13.473,8.953-25.327,22.586-25.327h105.595 c13.357,0,23.839,11.4,22.658,24.642l-7.542,84.582C2597.406,3087.135,2587.573,3096.092,2575.789,3096.092z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054962062216680400540000000422993208936673204_",
    gradientUnits: "userSpaceOnUse",
    x1: 2473.0327,
    y1: 3031.1152,
    x2: 2588.0317,
    y2: 3031.1152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054962062216680400540000000422993208936673204_)"
    },
    d: "M2564.978,3080.535h-66.901 c-8.768,0-16.15-6.523-17.19-15.188l-7.729-64.376c-1.231-10.255,6.814-19.277,17.19-19.277h80.37 c10.166,0,18.144,8.677,17.245,18.755l-5.739,64.376C2581.43,3073.719,2573.946,3080.535,2564.978,3080.535z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.3e657ecc968dea948d8bb8c2c9aa7ac6.svg";
export { ForwardRef as ReactComponent };